/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const PromptInitMessage = $root.PromptInitMessage = (() => {

    /**
     * Properties of a PromptInitMessage.
     * @exports IPromptInitMessage
     * @interface IPromptInitMessage
     * @property {number} id PromptInitMessage id
     * @property {number|null} [index] PromptInitMessage index
     * @property {number|null} [count] PromptInitMessage count
     * @property {Uint8Array} stateVector PromptInitMessage stateVector
     * @property {UpdateFormatVersion|null} [version] PromptInitMessage version
     * @property {number|null} [ySessionId] the session id of the Yjs document. Will only be sent by server.
     */

    /**
     * Constructs a new PromptInitMessage.
     * @exports PromptInitMessage
     * @classdesc Message sent by the client orserver to prompt the other side to send its
     * init message.
     * 
     * The `stateVector` represents the current state of the document. It's used to ensure the other side
     * can send a minimal update in its `init` message.
     * 
     * Yjs documents and their updates need a common history. Otherwise, Yjs will have bad conflict resolution behaviour
     * (e.g. overwriting content or missing content). The `ySessionId` is an identifier for a Yjs "common history".
     * Peers should only apply updates to a document where the ySessionId matches.
     * ySessionId is managed by the server. The value sent by client peers in promptInit will be ignored.
     * @implements IPromptInitMessage
     * @constructor
     * @param {IPromptInitMessage=} [properties] Properties to set
     */
    function PromptInitMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PromptInitMessage id.
     * @member {number} id
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.id = 0;

    /**
     * PromptInitMessage index.
     * @member {number} index
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.index = 0;

    /**
     * PromptInitMessage count.
     * @member {number} count
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.count = 0;

    /**
     * PromptInitMessage stateVector.
     * @member {Uint8Array} stateVector
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.stateVector = $util.newBuffer([]);

    /**
     * PromptInitMessage version.
     * @member {UpdateFormatVersion} version
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.version = 0;

    /**
     * the session id of the Yjs document. Will only be sent by server.
     * @member {number} ySessionId
     * @memberof PromptInitMessage
     * @instance
     */
    PromptInitMessage.prototype.ySessionId = 0;

    /**
     * Creates a new PromptInitMessage instance using the specified properties.
     * @function create
     * @memberof PromptInitMessage
     * @static
     * @param {IPromptInitMessage=} [properties] Properties to set
     * @returns {PromptInitMessage} PromptInitMessage instance
     */
    PromptInitMessage.create = function create(properties) {
        return new PromptInitMessage(properties);
    };

    /**
     * Encodes the specified PromptInitMessage message. Does not implicitly {@link PromptInitMessage.verify|verify} messages.
     * @function encode
     * @memberof PromptInitMessage
     * @static
     * @param {IPromptInitMessage} message PromptInitMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromptInitMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.index);
        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.count);
        writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.stateVector);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.version);
        if (message.ySessionId != null && Object.hasOwnProperty.call(message, "ySessionId"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ySessionId);
        return writer;
    };

    /**
     * Encodes the specified PromptInitMessage message, length delimited. Does not implicitly {@link PromptInitMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PromptInitMessage
     * @static
     * @param {IPromptInitMessage} message PromptInitMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PromptInitMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PromptInitMessage message from the specified reader or buffer.
     * @function decode
     * @memberof PromptInitMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PromptInitMessage} PromptInitMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromptInitMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PromptInitMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.index = reader.int32();
                    break;
                }
            case 3: {
                    message.count = reader.int32();
                    break;
                }
            case 4: {
                    message.stateVector = reader.bytes();
                    break;
                }
            case 5: {
                    message.version = reader.int32();
                    break;
                }
            case 6: {
                    message.ySessionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("stateVector"))
            throw $util.ProtocolError("missing required 'stateVector'", { instance: message });
        return message;
    };

    /**
     * Decodes a PromptInitMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PromptInitMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PromptInitMessage} PromptInitMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PromptInitMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PromptInitMessage message.
     * @function verify
     * @memberof PromptInitMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PromptInitMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.id))
            return "id: integer expected";
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        if (message.count != null && message.hasOwnProperty("count"))
            if (!$util.isInteger(message.count))
                return "count: integer expected";
        if (!(message.stateVector && typeof message.stateVector.length === "number" || $util.isString(message.stateVector)))
            return "stateVector: buffer expected";
        if (message.version != null && message.hasOwnProperty("version"))
            switch (message.version) {
            default:
                return "version: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            if (!$util.isInteger(message.ySessionId))
                return "ySessionId: integer expected";
        return null;
    };

    /**
     * Creates a PromptInitMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PromptInitMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PromptInitMessage} PromptInitMessage
     */
    PromptInitMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.PromptInitMessage)
            return object;
        let message = new $root.PromptInitMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.index != null)
            message.index = object.index | 0;
        if (object.count != null)
            message.count = object.count | 0;
        if (object.stateVector != null)
            if (typeof object.stateVector === "string")
                $util.base64.decode(object.stateVector, message.stateVector = $util.newBuffer($util.base64.length(object.stateVector)), 0);
            else if (object.stateVector.length >= 0)
                message.stateVector = object.stateVector;
        switch (object.version) {
        default:
            if (typeof object.version === "number") {
                message.version = object.version;
                break;
            }
            break;
        case "UNSPECIFIED":
        case 0:
            message.version = 0;
            break;
        case "V1":
        case 1:
            message.version = 1;
            break;
        case "V2":
        case 2:
            message.version = 2;
            break;
        }
        if (object.ySessionId != null)
            message.ySessionId = object.ySessionId | 0;
        return message;
    };

    /**
     * Creates a plain object from a PromptInitMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PromptInitMessage
     * @static
     * @param {PromptInitMessage} message PromptInitMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PromptInitMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = 0;
            object.index = 0;
            object.count = 0;
            if (options.bytes === String)
                object.stateVector = "";
            else {
                object.stateVector = [];
                if (options.bytes !== Array)
                    object.stateVector = $util.newBuffer(object.stateVector);
            }
            object.version = options.enums === String ? "UNSPECIFIED" : 0;
            object.ySessionId = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.count != null && message.hasOwnProperty("count"))
            object.count = message.count;
        if (message.stateVector != null && message.hasOwnProperty("stateVector"))
            object.stateVector = options.bytes === String ? $util.base64.encode(message.stateVector, 0, message.stateVector.length) : options.bytes === Array ? Array.prototype.slice.call(message.stateVector) : message.stateVector;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = options.enums === String ? $root.UpdateFormatVersion[message.version] === undefined ? message.version : $root.UpdateFormatVersion[message.version] : message.version;
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            object.ySessionId = message.ySessionId;
        return object;
    };

    /**
     * Converts this PromptInitMessage to JSON.
     * @function toJSON
     * @memberof PromptInitMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PromptInitMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PromptInitMessage
     * @function getTypeUrl
     * @memberof PromptInitMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PromptInitMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PromptInitMessage";
    };

    return PromptInitMessage;
})();

export const InitMessage = $root.InitMessage = (() => {

    /**
     * Properties of an InitMessage.
     * @exports IInitMessage
     * @interface IInitMessage
     * @property {number} id InitMessage id
     * @property {number|null} [index] InitMessage index
     * @property {number|null} [count] InitMessage count
     * @property {Uint8Array} update InitMessage update
     * @property {UpdateFormatVersion|null} [version] InitMessage version
     * @property {number|null} [ySessionId] the session id of the Yjs document. Will only be sent by server.
     */

    /**
     * Constructs a new InitMessage.
     * @exports InitMessage
     * @classdesc Message sent by the server to the newly connected client.
     * It contains the initial CRDT state update.
     * @implements IInitMessage
     * @constructor
     * @param {IInitMessage=} [properties] Properties to set
     */
    function InitMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InitMessage id.
     * @member {number} id
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.id = 0;

    /**
     * InitMessage index.
     * @member {number} index
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.index = 0;

    /**
     * InitMessage count.
     * @member {number} count
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.count = 0;

    /**
     * InitMessage update.
     * @member {Uint8Array} update
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.update = $util.newBuffer([]);

    /**
     * InitMessage version.
     * @member {UpdateFormatVersion} version
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.version = 0;

    /**
     * the session id of the Yjs document. Will only be sent by server.
     * @member {number} ySessionId
     * @memberof InitMessage
     * @instance
     */
    InitMessage.prototype.ySessionId = 0;

    /**
     * Creates a new InitMessage instance using the specified properties.
     * @function create
     * @memberof InitMessage
     * @static
     * @param {IInitMessage=} [properties] Properties to set
     * @returns {InitMessage} InitMessage instance
     */
    InitMessage.create = function create(properties) {
        return new InitMessage(properties);
    };

    /**
     * Encodes the specified InitMessage message. Does not implicitly {@link InitMessage.verify|verify} messages.
     * @function encode
     * @memberof InitMessage
     * @static
     * @param {IInitMessage} message InitMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InitMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.index);
        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.count);
        writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.update);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.version);
        if (message.ySessionId != null && Object.hasOwnProperty.call(message, "ySessionId"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ySessionId);
        return writer;
    };

    /**
     * Encodes the specified InitMessage message, length delimited. Does not implicitly {@link InitMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof InitMessage
     * @static
     * @param {IInitMessage} message InitMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InitMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an InitMessage message from the specified reader or buffer.
     * @function decode
     * @memberof InitMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InitMessage} InitMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InitMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InitMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.index = reader.int32();
                    break;
                }
            case 3: {
                    message.count = reader.int32();
                    break;
                }
            case 4: {
                    message.update = reader.bytes();
                    break;
                }
            case 5: {
                    message.version = reader.int32();
                    break;
                }
            case 6: {
                    message.ySessionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("update"))
            throw $util.ProtocolError("missing required 'update'", { instance: message });
        return message;
    };

    /**
     * Decodes an InitMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof InitMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {InitMessage} InitMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InitMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an InitMessage message.
     * @function verify
     * @memberof InitMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    InitMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.id))
            return "id: integer expected";
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        if (message.count != null && message.hasOwnProperty("count"))
            if (!$util.isInteger(message.count))
                return "count: integer expected";
        if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
            return "update: buffer expected";
        if (message.version != null && message.hasOwnProperty("version"))
            switch (message.version) {
            default:
                return "version: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            if (!$util.isInteger(message.ySessionId))
                return "ySessionId: integer expected";
        return null;
    };

    /**
     * Creates an InitMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InitMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InitMessage} InitMessage
     */
    InitMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.InitMessage)
            return object;
        let message = new $root.InitMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.index != null)
            message.index = object.index | 0;
        if (object.count != null)
            message.count = object.count | 0;
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length >= 0)
                message.update = object.update;
        switch (object.version) {
        default:
            if (typeof object.version === "number") {
                message.version = object.version;
                break;
            }
            break;
        case "UNSPECIFIED":
        case 0:
            message.version = 0;
            break;
        case "V1":
        case 1:
            message.version = 1;
            break;
        case "V2":
        case 2:
            message.version = 2;
            break;
        }
        if (object.ySessionId != null)
            message.ySessionId = object.ySessionId | 0;
        return message;
    };

    /**
     * Creates a plain object from an InitMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InitMessage
     * @static
     * @param {InitMessage} message InitMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InitMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = 0;
            object.index = 0;
            object.count = 0;
            if (options.bytes === String)
                object.update = "";
            else {
                object.update = [];
                if (options.bytes !== Array)
                    object.update = $util.newBuffer(object.update);
            }
            object.version = options.enums === String ? "UNSPECIFIED" : 0;
            object.ySessionId = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.count != null && message.hasOwnProperty("count"))
            object.count = message.count;
        if (message.update != null && message.hasOwnProperty("update"))
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = options.enums === String ? $root.UpdateFormatVersion[message.version] === undefined ? message.version : $root.UpdateFormatVersion[message.version] : message.version;
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            object.ySessionId = message.ySessionId;
        return object;
    };

    /**
     * Converts this InitMessage to JSON.
     * @function toJSON
     * @memberof InitMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InitMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for InitMessage
     * @function getTypeUrl
     * @memberof InitMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    InitMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/InitMessage";
    };

    return InitMessage;
})();

export const UpdateMessage = $root.UpdateMessage = (() => {

    /**
     * Properties of an UpdateMessage.
     * @exports IUpdateMessage
     * @interface IUpdateMessage
     * @property {number} id UpdateMessage id
     * @property {number|null} [index] UpdateMessage index
     * @property {number|null} [count] UpdateMessage count
     * @property {Uint8Array} update UpdateMessage update
     * @property {UpdateFormatVersion|null} [version] UpdateMessage version
     * @property {number|null} [ySessionId] the session id of the Yjs document. Sent by both client and server.
     */

    /**
     * Constructs a new UpdateMessage.
     * @exports UpdateMessage
     * @classdesc Message sent between server and client to notify about CRDT state update.
     * @implements IUpdateMessage
     * @constructor
     * @param {IUpdateMessage=} [properties] Properties to set
     */
    function UpdateMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateMessage id.
     * @member {number} id
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.id = 0;

    /**
     * UpdateMessage index.
     * @member {number} index
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.index = 0;

    /**
     * UpdateMessage count.
     * @member {number} count
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.count = 0;

    /**
     * UpdateMessage update.
     * @member {Uint8Array} update
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.update = $util.newBuffer([]);

    /**
     * UpdateMessage version.
     * @member {UpdateFormatVersion} version
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.version = 0;

    /**
     * the session id of the Yjs document. Sent by both client and server.
     * @member {number} ySessionId
     * @memberof UpdateMessage
     * @instance
     */
    UpdateMessage.prototype.ySessionId = 0;

    /**
     * Creates a new UpdateMessage instance using the specified properties.
     * @function create
     * @memberof UpdateMessage
     * @static
     * @param {IUpdateMessage=} [properties] Properties to set
     * @returns {UpdateMessage} UpdateMessage instance
     */
    UpdateMessage.create = function create(properties) {
        return new UpdateMessage(properties);
    };

    /**
     * Encodes the specified UpdateMessage message. Does not implicitly {@link UpdateMessage.verify|verify} messages.
     * @function encode
     * @memberof UpdateMessage
     * @static
     * @param {IUpdateMessage} message UpdateMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.index != null && Object.hasOwnProperty.call(message, "index"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.index);
        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.count);
        writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.update);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.version);
        if (message.ySessionId != null && Object.hasOwnProperty.call(message, "ySessionId"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ySessionId);
        return writer;
    };

    /**
     * Encodes the specified UpdateMessage message, length delimited. Does not implicitly {@link UpdateMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateMessage
     * @static
     * @param {IUpdateMessage} message UpdateMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateMessage message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateMessage} UpdateMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.index = reader.int32();
                    break;
                }
            case 3: {
                    message.count = reader.int32();
                    break;
                }
            case 4: {
                    message.update = reader.bytes();
                    break;
                }
            case 5: {
                    message.version = reader.int32();
                    break;
                }
            case 6: {
                    message.ySessionId = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("update"))
            throw $util.ProtocolError("missing required 'update'", { instance: message });
        return message;
    };

    /**
     * Decodes an UpdateMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateMessage} UpdateMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateMessage message.
     * @function verify
     * @memberof UpdateMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.id))
            return "id: integer expected";
        if (message.index != null && message.hasOwnProperty("index"))
            if (!$util.isInteger(message.index))
                return "index: integer expected";
        if (message.count != null && message.hasOwnProperty("count"))
            if (!$util.isInteger(message.count))
                return "count: integer expected";
        if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
            return "update: buffer expected";
        if (message.version != null && message.hasOwnProperty("version"))
            switch (message.version) {
            default:
                return "version: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            if (!$util.isInteger(message.ySessionId))
                return "ySessionId: integer expected";
        return null;
    };

    /**
     * Creates an UpdateMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateMessage} UpdateMessage
     */
    UpdateMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateMessage)
            return object;
        let message = new $root.UpdateMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.index != null)
            message.index = object.index | 0;
        if (object.count != null)
            message.count = object.count | 0;
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length >= 0)
                message.update = object.update;
        switch (object.version) {
        default:
            if (typeof object.version === "number") {
                message.version = object.version;
                break;
            }
            break;
        case "UNSPECIFIED":
        case 0:
            message.version = 0;
            break;
        case "V1":
        case 1:
            message.version = 1;
            break;
        case "V2":
        case 2:
            message.version = 2;
            break;
        }
        if (object.ySessionId != null)
            message.ySessionId = object.ySessionId | 0;
        return message;
    };

    /**
     * Creates a plain object from an UpdateMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateMessage
     * @static
     * @param {UpdateMessage} message UpdateMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = 0;
            object.index = 0;
            object.count = 0;
            if (options.bytes === String)
                object.update = "";
            else {
                object.update = [];
                if (options.bytes !== Array)
                    object.update = $util.newBuffer(object.update);
            }
            object.version = options.enums === String ? "UNSPECIFIED" : 0;
            object.ySessionId = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.index != null && message.hasOwnProperty("index"))
            object.index = message.index;
        if (message.count != null && message.hasOwnProperty("count"))
            object.count = message.count;
        if (message.update != null && message.hasOwnProperty("update"))
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = options.enums === String ? $root.UpdateFormatVersion[message.version] === undefined ? message.version : $root.UpdateFormatVersion[message.version] : message.version;
        if (message.ySessionId != null && message.hasOwnProperty("ySessionId"))
            object.ySessionId = message.ySessionId;
        return object;
    };

    /**
     * Converts this UpdateMessage to JSON.
     * @function toJSON
     * @memberof UpdateMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateMessage
     * @function getTypeUrl
     * @memberof UpdateMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateMessage";
    };

    return UpdateMessage;
})();

export const StoredUpdate = $root.StoredUpdate = (() => {

    /**
     * Properties of a StoredUpdate.
     * @exports IStoredUpdate
     * @interface IStoredUpdate
     * @property {Uint8Array} update StoredUpdate update
     * @property {UpdateFormatVersion} version StoredUpdate version
     */

    /**
     * Constructs a new StoredUpdate.
     * @exports StoredUpdate
     * @classdesc Update stored in a storage on the server.
     * @implements IStoredUpdate
     * @constructor
     * @param {IStoredUpdate=} [properties] Properties to set
     */
    function StoredUpdate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * StoredUpdate update.
     * @member {Uint8Array} update
     * @memberof StoredUpdate
     * @instance
     */
    StoredUpdate.prototype.update = $util.newBuffer([]);

    /**
     * StoredUpdate version.
     * @member {UpdateFormatVersion} version
     * @memberof StoredUpdate
     * @instance
     */
    StoredUpdate.prototype.version = 0;

    /**
     * Creates a new StoredUpdate instance using the specified properties.
     * @function create
     * @memberof StoredUpdate
     * @static
     * @param {IStoredUpdate=} [properties] Properties to set
     * @returns {StoredUpdate} StoredUpdate instance
     */
    StoredUpdate.create = function create(properties) {
        return new StoredUpdate(properties);
    };

    /**
     * Encodes the specified StoredUpdate message. Does not implicitly {@link StoredUpdate.verify|verify} messages.
     * @function encode
     * @memberof StoredUpdate
     * @static
     * @param {IStoredUpdate} message StoredUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StoredUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.update);
        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.version);
        return writer;
    };

    /**
     * Encodes the specified StoredUpdate message, length delimited. Does not implicitly {@link StoredUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StoredUpdate
     * @static
     * @param {IStoredUpdate} message StoredUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StoredUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StoredUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof StoredUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StoredUpdate} StoredUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StoredUpdate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StoredUpdate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 2: {
                    message.update = reader.bytes();
                    break;
                }
            case 3: {
                    message.version = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("update"))
            throw $util.ProtocolError("missing required 'update'", { instance: message });
        if (!message.hasOwnProperty("version"))
            throw $util.ProtocolError("missing required 'version'", { instance: message });
        return message;
    };

    /**
     * Decodes a StoredUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StoredUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StoredUpdate} StoredUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StoredUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StoredUpdate message.
     * @function verify
     * @memberof StoredUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StoredUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
            return "update: buffer expected";
        switch (message.version) {
        default:
            return "version: enum value expected";
        case 0:
        case 1:
        case 2:
            break;
        }
        return null;
    };

    /**
     * Creates a StoredUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StoredUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StoredUpdate} StoredUpdate
     */
    StoredUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.StoredUpdate)
            return object;
        let message = new $root.StoredUpdate();
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length >= 0)
                message.update = object.update;
        switch (object.version) {
        default:
            if (typeof object.version === "number") {
                message.version = object.version;
                break;
            }
            break;
        case "UNSPECIFIED":
        case 0:
            message.version = 0;
            break;
        case "V1":
        case 1:
            message.version = 1;
            break;
        case "V2":
        case 2:
            message.version = 2;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a StoredUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StoredUpdate
     * @static
     * @param {StoredUpdate} message StoredUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StoredUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.update = "";
            else {
                object.update = [];
                if (options.bytes !== Array)
                    object.update = $util.newBuffer(object.update);
            }
            object.version = options.enums === String ? "UNSPECIFIED" : 0;
        }
        if (message.update != null && message.hasOwnProperty("update"))
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = options.enums === String ? $root.UpdateFormatVersion[message.version] === undefined ? message.version : $root.UpdateFormatVersion[message.version] : message.version;
        return object;
    };

    /**
     * Converts this StoredUpdate to JSON.
     * @function toJSON
     * @memberof StoredUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StoredUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for StoredUpdate
     * @function getTypeUrl
     * @memberof StoredUpdate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    StoredUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StoredUpdate";
    };

    return StoredUpdate;
})();

export const UpdatePresenceMessage = $root.UpdatePresenceMessage = (() => {

    /**
     * Properties of an UpdatePresenceMessage.
     * @exports IUpdatePresenceMessage
     * @interface IUpdatePresenceMessage
     * @property {number} id UpdatePresenceMessage id
     * @property {Object.<string,string>|null} [data] UpdatePresenceMessage data
     * @property {Object.<string,Uint8Array>|null} [positions] UpdatePresenceMessage positions
     */

    /**
     * Constructs a new UpdatePresenceMessage.
     * @exports UpdatePresenceMessage
     * @classdesc Message sent by a client to the server to update the user presence.
     * @implements IUpdatePresenceMessage
     * @constructor
     * @param {IUpdatePresenceMessage=} [properties] Properties to set
     */
    function UpdatePresenceMessage(properties) {
        this.data = {};
        this.positions = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdatePresenceMessage id.
     * @member {number} id
     * @memberof UpdatePresenceMessage
     * @instance
     */
    UpdatePresenceMessage.prototype.id = 0;

    /**
     * UpdatePresenceMessage data.
     * @member {Object.<string,string>} data
     * @memberof UpdatePresenceMessage
     * @instance
     */
    UpdatePresenceMessage.prototype.data = $util.emptyObject;

    /**
     * UpdatePresenceMessage positions.
     * @member {Object.<string,Uint8Array>} positions
     * @memberof UpdatePresenceMessage
     * @instance
     */
    UpdatePresenceMessage.prototype.positions = $util.emptyObject;

    /**
     * Creates a new UpdatePresenceMessage instance using the specified properties.
     * @function create
     * @memberof UpdatePresenceMessage
     * @static
     * @param {IUpdatePresenceMessage=} [properties] Properties to set
     * @returns {UpdatePresenceMessage} UpdatePresenceMessage instance
     */
    UpdatePresenceMessage.create = function create(properties) {
        return new UpdatePresenceMessage(properties);
    };

    /**
     * Encodes the specified UpdatePresenceMessage message. Does not implicitly {@link UpdatePresenceMessage.verify|verify} messages.
     * @function encode
     * @memberof UpdatePresenceMessage
     * @static
     * @param {IUpdatePresenceMessage} message UpdatePresenceMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdatePresenceMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        if (message.positions != null && Object.hasOwnProperty.call(message, "positions"))
            for (let keys = Object.keys(message.positions), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).bytes(message.positions[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdatePresenceMessage message, length delimited. Does not implicitly {@link UpdatePresenceMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdatePresenceMessage
     * @static
     * @param {IUpdatePresenceMessage} message UpdatePresenceMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdatePresenceMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdatePresenceMessage message from the specified reader or buffer.
     * @function decode
     * @memberof UpdatePresenceMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdatePresenceMessage} UpdatePresenceMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdatePresenceMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdatePresenceMessage(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7);
                            break;
                        }
                    }
                    message.data[key] = value;
                    break;
                }
            case 3: {
                    if (message.positions === $util.emptyObject)
                        message.positions = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = [];
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag2 & 7);
                            break;
                        }
                    }
                    message.positions[key] = value;
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        return message;
    };

    /**
     * Decodes an UpdatePresenceMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdatePresenceMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdatePresenceMessage} UpdatePresenceMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdatePresenceMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdatePresenceMessage message.
     * @function verify
     * @memberof UpdatePresenceMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdatePresenceMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.id))
            return "id: integer expected";
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        if (message.positions != null && message.hasOwnProperty("positions")) {
            if (!$util.isObject(message.positions))
                return "positions: object expected";
            let key = Object.keys(message.positions);
            for (let i = 0; i < key.length; ++i)
                if (!(message.positions[key[i]] && typeof message.positions[key[i]].length === "number" || $util.isString(message.positions[key[i]])))
                    return "positions: buffer{k:string} expected";
        }
        return null;
    };

    /**
     * Creates an UpdatePresenceMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdatePresenceMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdatePresenceMessage} UpdatePresenceMessage
     */
    UpdatePresenceMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdatePresenceMessage)
            return object;
        let message = new $root.UpdatePresenceMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".UpdatePresenceMessage.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i)
                message.data[keys[i]] = String(object.data[keys[i]]);
        }
        if (object.positions) {
            if (typeof object.positions !== "object")
                throw TypeError(".UpdatePresenceMessage.positions: object expected");
            message.positions = {};
            for (let keys = Object.keys(object.positions), i = 0; i < keys.length; ++i)
                if (typeof object.positions[keys[i]] === "string")
                    $util.base64.decode(object.positions[keys[i]], message.positions[keys[i]] = $util.newBuffer($util.base64.length(object.positions[keys[i]])), 0);
                else if (object.positions[keys[i]].length >= 0)
                    message.positions[keys[i]] = object.positions[keys[i]];
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdatePresenceMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdatePresenceMessage
     * @static
     * @param {UpdatePresenceMessage} message UpdatePresenceMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdatePresenceMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults) {
            object.data = {};
            object.positions = {};
        }
        if (options.defaults)
            object.id = 0;
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j)
                object.data[keys2[j]] = message.data[keys2[j]];
        }
        if (message.positions && (keys2 = Object.keys(message.positions)).length) {
            object.positions = {};
            for (let j = 0; j < keys2.length; ++j)
                object.positions[keys2[j]] = options.bytes === String ? $util.base64.encode(message.positions[keys2[j]], 0, message.positions[keys2[j]].length) : options.bytes === Array ? Array.prototype.slice.call(message.positions[keys2[j]]) : message.positions[keys2[j]];
        }
        return object;
    };

    /**
     * Converts this UpdatePresenceMessage to JSON.
     * @function toJSON
     * @memberof UpdatePresenceMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdatePresenceMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdatePresenceMessage
     * @function getTypeUrl
     * @memberof UpdatePresenceMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdatePresenceMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdatePresenceMessage";
    };

    return UpdatePresenceMessage;
})();

export const AckMessage = $root.AckMessage = (() => {

    /**
     * Properties of an AckMessage.
     * @exports IAckMessage
     * @interface IAckMessage
     * @property {number} id AckMessage id
     * @property {number} message AckMessage message
     */

    /**
     * Constructs a new AckMessage.
     * @exports AckMessage
     * @classdesc Message sent by the server to acknowledge the reception of a message.
     * @implements IAckMessage
     * @constructor
     * @param {IAckMessage=} [properties] Properties to set
     */
    function AckMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AckMessage id.
     * @member {number} id
     * @memberof AckMessage
     * @instance
     */
    AckMessage.prototype.id = 0;

    /**
     * AckMessage message.
     * @member {number} message
     * @memberof AckMessage
     * @instance
     */
    AckMessage.prototype.message = 0;

    /**
     * Creates a new AckMessage instance using the specified properties.
     * @function create
     * @memberof AckMessage
     * @static
     * @param {IAckMessage=} [properties] Properties to set
     * @returns {AckMessage} AckMessage instance
     */
    AckMessage.create = function create(properties) {
        return new AckMessage(properties);
    };

    /**
     * Encodes the specified AckMessage message. Does not implicitly {@link AckMessage.verify|verify} messages.
     * @function encode
     * @memberof AckMessage
     * @static
     * @param {IAckMessage} message AckMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AckMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.message);
        return writer;
    };

    /**
     * Encodes the specified AckMessage message, length delimited. Does not implicitly {@link AckMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AckMessage
     * @static
     * @param {IAckMessage} message AckMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AckMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AckMessage message from the specified reader or buffer.
     * @function decode
     * @memberof AckMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AckMessage} AckMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AckMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AckMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.message = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    /**
     * Decodes an AckMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AckMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AckMessage} AckMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AckMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AckMessage message.
     * @function verify
     * @memberof AckMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AckMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.id))
            return "id: integer expected";
        if (!$util.isInteger(message.message))
            return "message: integer expected";
        return null;
    };

    /**
     * Creates an AckMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AckMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AckMessage} AckMessage
     */
    AckMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.AckMessage)
            return object;
        let message = new $root.AckMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.message != null)
            message.message = object.message | 0;
        return message;
    };

    /**
     * Creates a plain object from an AckMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AckMessage
     * @static
     * @param {AckMessage} message AckMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AckMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = 0;
            object.message = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        return object;
    };

    /**
     * Converts this AckMessage to JSON.
     * @function toJSON
     * @memberof AckMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AckMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AckMessage
     * @function getTypeUrl
     * @memberof AckMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AckMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AckMessage";
    };

    return AckMessage;
})();

export const BroadcastPresencesMessage = $root.BroadcastPresencesMessage = (() => {

    /**
     * Properties of a BroadcastPresencesMessage.
     * @exports IBroadcastPresencesMessage
     * @interface IBroadcastPresencesMessage
     * @property {number} id BroadcastPresencesMessage id
     * @property {Object.<string,IPresence>|null} [presences] BroadcastPresencesMessage presences
     * @property {string} selfClientId BroadcastPresencesMessage selfClientId
     */

    /**
     * Constructs a new BroadcastPresencesMessage.
     * @exports BroadcastPresencesMessage
     * @classdesc Message sent by a client to the server to update the user presence.
     * @implements IBroadcastPresencesMessage
     * @constructor
     * @param {IBroadcastPresencesMessage=} [properties] Properties to set
     */
    function BroadcastPresencesMessage(properties) {
        this.presences = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BroadcastPresencesMessage id.
     * @member {number} id
     * @memberof BroadcastPresencesMessage
     * @instance
     */
    BroadcastPresencesMessage.prototype.id = 0;

    /**
     * BroadcastPresencesMessage presences.
     * @member {Object.<string,IPresence>} presences
     * @memberof BroadcastPresencesMessage
     * @instance
     */
    BroadcastPresencesMessage.prototype.presences = $util.emptyObject;

    /**
     * BroadcastPresencesMessage selfClientId.
     * @member {string} selfClientId
     * @memberof BroadcastPresencesMessage
     * @instance
     */
    BroadcastPresencesMessage.prototype.selfClientId = "";

    /**
     * Creates a new BroadcastPresencesMessage instance using the specified properties.
     * @function create
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {IBroadcastPresencesMessage=} [properties] Properties to set
     * @returns {BroadcastPresencesMessage} BroadcastPresencesMessage instance
     */
    BroadcastPresencesMessage.create = function create(properties) {
        return new BroadcastPresencesMessage(properties);
    };

    /**
     * Encodes the specified BroadcastPresencesMessage message. Does not implicitly {@link BroadcastPresencesMessage.verify|verify} messages.
     * @function encode
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {IBroadcastPresencesMessage} message BroadcastPresencesMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastPresencesMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        if (message.presences != null && Object.hasOwnProperty.call(message, "presences"))
            for (let keys = Object.keys(message.presences), i = 0; i < keys.length; ++i) {
                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                $root.Presence.encode(message.presences[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
            }
        writer.uint32(/* id 3, wireType 2 =*/26).string(message.selfClientId);
        return writer;
    };

    /**
     * Encodes the specified BroadcastPresencesMessage message, length delimited. Does not implicitly {@link BroadcastPresencesMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {IBroadcastPresencesMessage} message BroadcastPresencesMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastPresencesMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BroadcastPresencesMessage message from the specified reader or buffer.
     * @function decode
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BroadcastPresencesMessage} BroadcastPresencesMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastPresencesMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BroadcastPresencesMessage(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    if (message.presences === $util.emptyObject)
                        message.presences = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = null;
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = $root.Presence.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag2 & 7);
                            break;
                        }
                    }
                    message.presences[key] = value;
                    break;
                }
            case 3: {
                    message.selfClientId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("selfClientId"))
            throw $util.ProtocolError("missing required 'selfClientId'", { instance: message });
        return message;
    };

    /**
     * Decodes a BroadcastPresencesMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BroadcastPresencesMessage} BroadcastPresencesMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastPresencesMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BroadcastPresencesMessage message.
     * @function verify
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BroadcastPresencesMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.id))
            return "id: integer expected";
        if (message.presences != null && message.hasOwnProperty("presences")) {
            if (!$util.isObject(message.presences))
                return "presences: object expected";
            let key = Object.keys(message.presences);
            for (let i = 0; i < key.length; ++i) {
                let error = $root.Presence.verify(message.presences[key[i]]);
                if (error)
                    return "presences." + error;
            }
        }
        if (!$util.isString(message.selfClientId))
            return "selfClientId: string expected";
        return null;
    };

    /**
     * Creates a BroadcastPresencesMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BroadcastPresencesMessage} BroadcastPresencesMessage
     */
    BroadcastPresencesMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.BroadcastPresencesMessage)
            return object;
        let message = new $root.BroadcastPresencesMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.presences) {
            if (typeof object.presences !== "object")
                throw TypeError(".BroadcastPresencesMessage.presences: object expected");
            message.presences = {};
            for (let keys = Object.keys(object.presences), i = 0; i < keys.length; ++i) {
                if (typeof object.presences[keys[i]] !== "object")
                    throw TypeError(".BroadcastPresencesMessage.presences: object expected");
                message.presences[keys[i]] = $root.Presence.fromObject(object.presences[keys[i]]);
            }
        }
        if (object.selfClientId != null)
            message.selfClientId = String(object.selfClientId);
        return message;
    };

    /**
     * Creates a plain object from a BroadcastPresencesMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {BroadcastPresencesMessage} message BroadcastPresencesMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BroadcastPresencesMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.presences = {};
        if (options.defaults) {
            object.id = 0;
            object.selfClientId = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        let keys2;
        if (message.presences && (keys2 = Object.keys(message.presences)).length) {
            object.presences = {};
            for (let j = 0; j < keys2.length; ++j)
                object.presences[keys2[j]] = $root.Presence.toObject(message.presences[keys2[j]], options);
        }
        if (message.selfClientId != null && message.hasOwnProperty("selfClientId"))
            object.selfClientId = message.selfClientId;
        return object;
    };

    /**
     * Converts this BroadcastPresencesMessage to JSON.
     * @function toJSON
     * @memberof BroadcastPresencesMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BroadcastPresencesMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BroadcastPresencesMessage
     * @function getTypeUrl
     * @memberof BroadcastPresencesMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BroadcastPresencesMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BroadcastPresencesMessage";
    };

    return BroadcastPresencesMessage;
})();

export const BroadcastOperationMessage = $root.BroadcastOperationMessage = (() => {

    /**
     * Properties of a BroadcastOperationMessage.
     * @exports IBroadcastOperationMessage
     * @interface IBroadcastOperationMessage
     * @property {number} id BroadcastOperationMessage id
     * @property {IContentOperation} operation BroadcastOperationMessage operation
     */

    /**
     * Constructs a new BroadcastOperationMessage.
     * @exports BroadcastOperationMessage
     * @classdesc Message sent by one side with generic data to the other side.
     * @implements IBroadcastOperationMessage
     * @constructor
     * @param {IBroadcastOperationMessage=} [properties] Properties to set
     */
    function BroadcastOperationMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BroadcastOperationMessage id.
     * @member {number} id
     * @memberof BroadcastOperationMessage
     * @instance
     */
    BroadcastOperationMessage.prototype.id = 0;

    /**
     * BroadcastOperationMessage operation.
     * @member {IContentOperation} operation
     * @memberof BroadcastOperationMessage
     * @instance
     */
    BroadcastOperationMessage.prototype.operation = null;

    /**
     * Creates a new BroadcastOperationMessage instance using the specified properties.
     * @function create
     * @memberof BroadcastOperationMessage
     * @static
     * @param {IBroadcastOperationMessage=} [properties] Properties to set
     * @returns {BroadcastOperationMessage} BroadcastOperationMessage instance
     */
    BroadcastOperationMessage.create = function create(properties) {
        return new BroadcastOperationMessage(properties);
    };

    /**
     * Encodes the specified BroadcastOperationMessage message. Does not implicitly {@link BroadcastOperationMessage.verify|verify} messages.
     * @function encode
     * @memberof BroadcastOperationMessage
     * @static
     * @param {IBroadcastOperationMessage} message BroadcastOperationMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastOperationMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        $root.ContentOperation.encode(message.operation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified BroadcastOperationMessage message, length delimited. Does not implicitly {@link BroadcastOperationMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BroadcastOperationMessage
     * @static
     * @param {IBroadcastOperationMessage} message BroadcastOperationMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BroadcastOperationMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BroadcastOperationMessage message from the specified reader or buffer.
     * @function decode
     * @memberof BroadcastOperationMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BroadcastOperationMessage} BroadcastOperationMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastOperationMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BroadcastOperationMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.operation = $root.ContentOperation.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("operation"))
            throw $util.ProtocolError("missing required 'operation'", { instance: message });
        return message;
    };

    /**
     * Decodes a BroadcastOperationMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BroadcastOperationMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BroadcastOperationMessage} BroadcastOperationMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BroadcastOperationMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BroadcastOperationMessage message.
     * @function verify
     * @memberof BroadcastOperationMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BroadcastOperationMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.id))
            return "id: integer expected";
        {
            let error = $root.ContentOperation.verify(message.operation);
            if (error)
                return "operation." + error;
        }
        return null;
    };

    /**
     * Creates a BroadcastOperationMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BroadcastOperationMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BroadcastOperationMessage} BroadcastOperationMessage
     */
    BroadcastOperationMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.BroadcastOperationMessage)
            return object;
        let message = new $root.BroadcastOperationMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.operation != null) {
            if (typeof object.operation !== "object")
                throw TypeError(".BroadcastOperationMessage.operation: object expected");
            message.operation = $root.ContentOperation.fromObject(object.operation);
        }
        return message;
    };

    /**
     * Creates a plain object from a BroadcastOperationMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BroadcastOperationMessage
     * @static
     * @param {BroadcastOperationMessage} message BroadcastOperationMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BroadcastOperationMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = 0;
            object.operation = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.operation != null && message.hasOwnProperty("operation"))
            object.operation = $root.ContentOperation.toObject(message.operation, options);
        return object;
    };

    /**
     * Converts this BroadcastOperationMessage to JSON.
     * @function toJSON
     * @memberof BroadcastOperationMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BroadcastOperationMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BroadcastOperationMessage
     * @function getTypeUrl
     * @memberof BroadcastOperationMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BroadcastOperationMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BroadcastOperationMessage";
    };

    return BroadcastOperationMessage;
})();

export const RPCRequestMessage = $root.RPCRequestMessage = (() => {

    /**
     * Properties of a RPCRequestMessage.
     * @exports IRPCRequestMessage
     * @interface IRPCRequestMessage
     * @property {number} id RPCRequestMessage id
     * @property {string} service RPCRequestMessage service
     * @property {string} method RPCRequestMessage method
     * @property {Uint8Array} payload RPCRequestMessage payload
     */

    /**
     * Constructs a new RPCRequestMessage.
     * @exports RPCRequestMessage
     * @classdesc Message sent by one side with a generic RPC request to the other side.
     * @implements IRPCRequestMessage
     * @constructor
     * @param {IRPCRequestMessage=} [properties] Properties to set
     */
    function RPCRequestMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RPCRequestMessage id.
     * @member {number} id
     * @memberof RPCRequestMessage
     * @instance
     */
    RPCRequestMessage.prototype.id = 0;

    /**
     * RPCRequestMessage service.
     * @member {string} service
     * @memberof RPCRequestMessage
     * @instance
     */
    RPCRequestMessage.prototype.service = "";

    /**
     * RPCRequestMessage method.
     * @member {string} method
     * @memberof RPCRequestMessage
     * @instance
     */
    RPCRequestMessage.prototype.method = "";

    /**
     * RPCRequestMessage payload.
     * @member {Uint8Array} payload
     * @memberof RPCRequestMessage
     * @instance
     */
    RPCRequestMessage.prototype.payload = $util.newBuffer([]);

    /**
     * Creates a new RPCRequestMessage instance using the specified properties.
     * @function create
     * @memberof RPCRequestMessage
     * @static
     * @param {IRPCRequestMessage=} [properties] Properties to set
     * @returns {RPCRequestMessage} RPCRequestMessage instance
     */
    RPCRequestMessage.create = function create(properties) {
        return new RPCRequestMessage(properties);
    };

    /**
     * Encodes the specified RPCRequestMessage message. Does not implicitly {@link RPCRequestMessage.verify|verify} messages.
     * @function encode
     * @memberof RPCRequestMessage
     * @static
     * @param {IRPCRequestMessage} message RPCRequestMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCRequestMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.service);
        writer.uint32(/* id 3, wireType 2 =*/26).string(message.method);
        writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.payload);
        return writer;
    };

    /**
     * Encodes the specified RPCRequestMessage message, length delimited. Does not implicitly {@link RPCRequestMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RPCRequestMessage
     * @static
     * @param {IRPCRequestMessage} message RPCRequestMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCRequestMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RPCRequestMessage message from the specified reader or buffer.
     * @function decode
     * @memberof RPCRequestMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RPCRequestMessage} RPCRequestMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCRequestMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RPCRequestMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.service = reader.string();
                    break;
                }
            case 3: {
                    message.method = reader.string();
                    break;
                }
            case 4: {
                    message.payload = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("service"))
            throw $util.ProtocolError("missing required 'service'", { instance: message });
        if (!message.hasOwnProperty("method"))
            throw $util.ProtocolError("missing required 'method'", { instance: message });
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    /**
     * Decodes a RPCRequestMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RPCRequestMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RPCRequestMessage} RPCRequestMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCRequestMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RPCRequestMessage message.
     * @function verify
     * @memberof RPCRequestMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RPCRequestMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.id))
            return "id: integer expected";
        if (!$util.isString(message.service))
            return "service: string expected";
        if (!$util.isString(message.method))
            return "method: string expected";
        if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
            return "payload: buffer expected";
        return null;
    };

    /**
     * Creates a RPCRequestMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RPCRequestMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RPCRequestMessage} RPCRequestMessage
     */
    RPCRequestMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.RPCRequestMessage)
            return object;
        let message = new $root.RPCRequestMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.service != null)
            message.service = String(object.service);
        if (object.method != null)
            message.method = String(object.method);
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length >= 0)
                message.payload = object.payload;
        return message;
    };

    /**
     * Creates a plain object from a RPCRequestMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RPCRequestMessage
     * @static
     * @param {RPCRequestMessage} message RPCRequestMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RPCRequestMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = 0;
            object.service = "";
            object.method = "";
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.service != null && message.hasOwnProperty("service"))
            object.service = message.service;
        if (message.method != null && message.hasOwnProperty("method"))
            object.method = message.method;
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        return object;
    };

    /**
     * Converts this RPCRequestMessage to JSON.
     * @function toJSON
     * @memberof RPCRequestMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RPCRequestMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RPCRequestMessage
     * @function getTypeUrl
     * @memberof RPCRequestMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RPCRequestMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RPCRequestMessage";
    };

    return RPCRequestMessage;
})();

export const RPCReplyMessage = $root.RPCReplyMessage = (() => {

    /**
     * Properties of a RPCReplyMessage.
     * @exports IRPCReplyMessage
     * @interface IRPCReplyMessage
     * @property {number} id RPCReplyMessage id
     * @property {number} replyTo RPCReplyMessage replyTo
     * @property {Uint8Array|null} [payload] RPCReplyMessage payload
     * @property {IRPCError|null} [error] RPCReplyMessage error
     */

    /**
     * Constructs a new RPCReplyMessage.
     * @exports RPCReplyMessage
     * @classdesc Message sent by one side with a generic RPC reply to the other side.
     * @implements IRPCReplyMessage
     * @constructor
     * @param {IRPCReplyMessage=} [properties] Properties to set
     */
    function RPCReplyMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RPCReplyMessage id.
     * @member {number} id
     * @memberof RPCReplyMessage
     * @instance
     */
    RPCReplyMessage.prototype.id = 0;

    /**
     * RPCReplyMessage replyTo.
     * @member {number} replyTo
     * @memberof RPCReplyMessage
     * @instance
     */
    RPCReplyMessage.prototype.replyTo = 0;

    /**
     * RPCReplyMessage payload.
     * @member {Uint8Array} payload
     * @memberof RPCReplyMessage
     * @instance
     */
    RPCReplyMessage.prototype.payload = $util.newBuffer([]);

    /**
     * RPCReplyMessage error.
     * @member {IRPCError|null|undefined} error
     * @memberof RPCReplyMessage
     * @instance
     */
    RPCReplyMessage.prototype.error = null;

    /**
     * Creates a new RPCReplyMessage instance using the specified properties.
     * @function create
     * @memberof RPCReplyMessage
     * @static
     * @param {IRPCReplyMessage=} [properties] Properties to set
     * @returns {RPCReplyMessage} RPCReplyMessage instance
     */
    RPCReplyMessage.create = function create(properties) {
        return new RPCReplyMessage(properties);
    };

    /**
     * Encodes the specified RPCReplyMessage message. Does not implicitly {@link RPCReplyMessage.verify|verify} messages.
     * @function encode
     * @memberof RPCReplyMessage
     * @static
     * @param {IRPCReplyMessage} message RPCReplyMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCReplyMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.replyTo);
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.payload);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            $root.RPCError.encode(message.error, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified RPCReplyMessage message, length delimited. Does not implicitly {@link RPCReplyMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RPCReplyMessage
     * @static
     * @param {IRPCReplyMessage} message RPCReplyMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCReplyMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RPCReplyMessage message from the specified reader or buffer.
     * @function decode
     * @memberof RPCReplyMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RPCReplyMessage} RPCReplyMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCReplyMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RPCReplyMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.int32();
                    break;
                }
            case 2: {
                    message.replyTo = reader.int32();
                    break;
                }
            case 3: {
                    message.payload = reader.bytes();
                    break;
                }
            case 4: {
                    message.error = $root.RPCError.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("replyTo"))
            throw $util.ProtocolError("missing required 'replyTo'", { instance: message });
        return message;
    };

    /**
     * Decodes a RPCReplyMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RPCReplyMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RPCReplyMessage} RPCReplyMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCReplyMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RPCReplyMessage message.
     * @function verify
     * @memberof RPCReplyMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RPCReplyMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.id))
            return "id: integer expected";
        if (!$util.isInteger(message.replyTo))
            return "replyTo: integer expected";
        if (message.payload != null && message.hasOwnProperty("payload"))
            if (!(message.payload && typeof message.payload.length === "number" || $util.isString(message.payload)))
                return "payload: buffer expected";
        if (message.error != null && message.hasOwnProperty("error")) {
            let error = $root.RPCError.verify(message.error);
            if (error)
                return "error." + error;
        }
        return null;
    };

    /**
     * Creates a RPCReplyMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RPCReplyMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RPCReplyMessage} RPCReplyMessage
     */
    RPCReplyMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.RPCReplyMessage)
            return object;
        let message = new $root.RPCReplyMessage();
        if (object.id != null)
            message.id = object.id | 0;
        if (object.replyTo != null)
            message.replyTo = object.replyTo | 0;
        if (object.payload != null)
            if (typeof object.payload === "string")
                $util.base64.decode(object.payload, message.payload = $util.newBuffer($util.base64.length(object.payload)), 0);
            else if (object.payload.length >= 0)
                message.payload = object.payload;
        if (object.error != null) {
            if (typeof object.error !== "object")
                throw TypeError(".RPCReplyMessage.error: object expected");
            message.error = $root.RPCError.fromObject(object.error);
        }
        return message;
    };

    /**
     * Creates a plain object from a RPCReplyMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RPCReplyMessage
     * @static
     * @param {RPCReplyMessage} message RPCReplyMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RPCReplyMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = 0;
            object.replyTo = 0;
            if (options.bytes === String)
                object.payload = "";
            else {
                object.payload = [];
                if (options.bytes !== Array)
                    object.payload = $util.newBuffer(object.payload);
            }
            object.error = null;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.replyTo != null && message.hasOwnProperty("replyTo"))
            object.replyTo = message.replyTo;
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = options.bytes === String ? $util.base64.encode(message.payload, 0, message.payload.length) : options.bytes === Array ? Array.prototype.slice.call(message.payload) : message.payload;
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = $root.RPCError.toObject(message.error, options);
        return object;
    };

    /**
     * Converts this RPCReplyMessage to JSON.
     * @function toJSON
     * @memberof RPCReplyMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RPCReplyMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RPCReplyMessage
     * @function getTypeUrl
     * @memberof RPCReplyMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RPCReplyMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RPCReplyMessage";
    };

    return RPCReplyMessage;
})();

export const RPCError = $root.RPCError = (() => {

    /**
     * Properties of a RPCError.
     * @exports IRPCError
     * @interface IRPCError
     * @property {number} code RPCError code
     * @property {string} message RPCError message
     */

    /**
     * Constructs a new RPCError.
     * @exports RPCError
     * @classdesc Represents a RPCError.
     * @implements IRPCError
     * @constructor
     * @param {IRPCError=} [properties] Properties to set
     */
    function RPCError(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RPCError code.
     * @member {number} code
     * @memberof RPCError
     * @instance
     */
    RPCError.prototype.code = 0;

    /**
     * RPCError message.
     * @member {string} message
     * @memberof RPCError
     * @instance
     */
    RPCError.prototype.message = "";

    /**
     * Creates a new RPCError instance using the specified properties.
     * @function create
     * @memberof RPCError
     * @static
     * @param {IRPCError=} [properties] Properties to set
     * @returns {RPCError} RPCError instance
     */
    RPCError.create = function create(properties) {
        return new RPCError(properties);
    };

    /**
     * Encodes the specified RPCError message. Does not implicitly {@link RPCError.verify|verify} messages.
     * @function encode
     * @memberof RPCError
     * @static
     * @param {IRPCError} message RPCError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCError.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
        return writer;
    };

    /**
     * Encodes the specified RPCError message, length delimited. Does not implicitly {@link RPCError.verify|verify} messages.
     * @function encodeDelimited
     * @memberof RPCError
     * @static
     * @param {IRPCError} message RPCError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RPCError.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a RPCError message from the specified reader or buffer.
     * @function decode
     * @memberof RPCError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RPCError} RPCError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCError.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RPCError();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.code = reader.int32();
                    break;
                }
            case 2: {
                    message.message = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("code"))
            throw $util.ProtocolError("missing required 'code'", { instance: message });
        if (!message.hasOwnProperty("message"))
            throw $util.ProtocolError("missing required 'message'", { instance: message });
        return message;
    };

    /**
     * Decodes a RPCError message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof RPCError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {RPCError} RPCError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RPCError.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a RPCError message.
     * @function verify
     * @memberof RPCError
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    RPCError.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.code))
            return "code: integer expected";
        if (!$util.isString(message.message))
            return "message: string expected";
        return null;
    };

    /**
     * Creates a RPCError message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RPCError
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RPCError} RPCError
     */
    RPCError.fromObject = function fromObject(object) {
        if (object instanceof $root.RPCError)
            return object;
        let message = new $root.RPCError();
        if (object.code != null)
            message.code = object.code | 0;
        if (object.message != null)
            message.message = String(object.message);
        return message;
    };

    /**
     * Creates a plain object from a RPCError message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RPCError
     * @static
     * @param {RPCError} message RPCError
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RPCError.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.code = 0;
            object.message = "";
        }
        if (message.code != null && message.hasOwnProperty("code"))
            object.code = message.code;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        return object;
    };

    /**
     * Converts this RPCError to JSON.
     * @function toJSON
     * @memberof RPCError
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RPCError.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RPCError
     * @function getTypeUrl
     * @memberof RPCError
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RPCError.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RPCError";
    };

    return RPCError;
})();

export const Message = $root.Message = (() => {

    /**
     * Properties of a Message.
     * @exports IMessage
     * @interface IMessage
     * @property {IPromptInitMessage|null} [promptInit] Message promptInit
     * @property {IInitMessage|null} [init] Message init
     * @property {IUpdateMessage|null} [update] Message update
     * @property {IUpdatePresenceMessage|null} [updatePresence] Message updatePresence
     * @property {IBroadcastPresencesMessage|null} [broadcastPresences] Message broadcastPresences
     * @property {IBroadcastOperationMessage|null} [broadcastOperation] Message broadcastOperation
     * @property {IAckMessage|null} [ack] Message ack
     * @property {IRPCRequestMessage|null} [rpcRequest] Message rpcRequest
     * @property {IRPCReplyMessage|null} [rpcReply] Message rpcReply
     */

    /**
     * Constructs a new Message.
     * @exports Message
     * @classdesc Any message that can be sent between the client and the server.
     * @implements IMessage
     * @constructor
     * @param {IMessage=} [properties] Properties to set
     */
    function Message(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Message promptInit.
     * @member {IPromptInitMessage|null|undefined} promptInit
     * @memberof Message
     * @instance
     */
    Message.prototype.promptInit = null;

    /**
     * Message init.
     * @member {IInitMessage|null|undefined} init
     * @memberof Message
     * @instance
     */
    Message.prototype.init = null;

    /**
     * Message update.
     * @member {IUpdateMessage|null|undefined} update
     * @memberof Message
     * @instance
     */
    Message.prototype.update = null;

    /**
     * Message updatePresence.
     * @member {IUpdatePresenceMessage|null|undefined} updatePresence
     * @memberof Message
     * @instance
     */
    Message.prototype.updatePresence = null;

    /**
     * Message broadcastPresences.
     * @member {IBroadcastPresencesMessage|null|undefined} broadcastPresences
     * @memberof Message
     * @instance
     */
    Message.prototype.broadcastPresences = null;

    /**
     * Message broadcastOperation.
     * @member {IBroadcastOperationMessage|null|undefined} broadcastOperation
     * @memberof Message
     * @instance
     */
    Message.prototype.broadcastOperation = null;

    /**
     * Message ack.
     * @member {IAckMessage|null|undefined} ack
     * @memberof Message
     * @instance
     */
    Message.prototype.ack = null;

    /**
     * Message rpcRequest.
     * @member {IRPCRequestMessage|null|undefined} rpcRequest
     * @memberof Message
     * @instance
     */
    Message.prototype.rpcRequest = null;

    /**
     * Message rpcReply.
     * @member {IRPCReplyMessage|null|undefined} rpcReply
     * @memberof Message
     * @instance
     */
    Message.prototype.rpcReply = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * Message message.
     * @member {"promptInit"|"init"|"update"|"updatePresence"|"broadcastPresences"|"broadcastOperation"|"ack"|"rpcRequest"|"rpcReply"|undefined} message
     * @memberof Message
     * @instance
     */
    Object.defineProperty(Message.prototype, "message", {
        get: $util.oneOfGetter($oneOfFields = ["promptInit", "init", "update", "updatePresence", "broadcastPresences", "broadcastOperation", "ack", "rpcRequest", "rpcReply"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new Message instance using the specified properties.
     * @function create
     * @memberof Message
     * @static
     * @param {IMessage=} [properties] Properties to set
     * @returns {Message} Message instance
     */
    Message.create = function create(properties) {
        return new Message(properties);
    };

    /**
     * Encodes the specified Message message. Does not implicitly {@link Message.verify|verify} messages.
     * @function encode
     * @memberof Message
     * @static
     * @param {IMessage} message Message message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Message.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.promptInit != null && Object.hasOwnProperty.call(message, "promptInit"))
            $root.PromptInitMessage.encode(message.promptInit, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.init != null && Object.hasOwnProperty.call(message, "init"))
            $root.InitMessage.encode(message.init, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.update != null && Object.hasOwnProperty.call(message, "update"))
            $root.UpdateMessage.encode(message.update, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.updatePresence != null && Object.hasOwnProperty.call(message, "updatePresence"))
            $root.UpdatePresenceMessage.encode(message.updatePresence, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.broadcastPresences != null && Object.hasOwnProperty.call(message, "broadcastPresences"))
            $root.BroadcastPresencesMessage.encode(message.broadcastPresences, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.broadcastOperation != null && Object.hasOwnProperty.call(message, "broadcastOperation"))
            $root.BroadcastOperationMessage.encode(message.broadcastOperation, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.ack != null && Object.hasOwnProperty.call(message, "ack"))
            $root.AckMessage.encode(message.ack, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.rpcRequest != null && Object.hasOwnProperty.call(message, "rpcRequest"))
            $root.RPCRequestMessage.encode(message.rpcRequest, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.rpcReply != null && Object.hasOwnProperty.call(message, "rpcReply"))
            $root.RPCReplyMessage.encode(message.rpcReply, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Message message, length delimited. Does not implicitly {@link Message.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Message
     * @static
     * @param {IMessage} message Message message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Message.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Message message from the specified reader or buffer.
     * @function decode
     * @memberof Message
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Message} Message
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Message.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Message();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.promptInit = $root.PromptInitMessage.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.init = $root.InitMessage.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.update = $root.UpdateMessage.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.updatePresence = $root.UpdatePresenceMessage.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.broadcastPresences = $root.BroadcastPresencesMessage.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.broadcastOperation = $root.BroadcastOperationMessage.decode(reader, reader.uint32());
                    break;
                }
            case 7: {
                    message.ack = $root.AckMessage.decode(reader, reader.uint32());
                    break;
                }
            case 8: {
                    message.rpcRequest = $root.RPCRequestMessage.decode(reader, reader.uint32());
                    break;
                }
            case 9: {
                    message.rpcReply = $root.RPCReplyMessage.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Message message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Message
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Message} Message
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Message.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Message message.
     * @function verify
     * @memberof Message
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Message.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.promptInit != null && message.hasOwnProperty("promptInit")) {
            properties.message = 1;
            {
                let error = $root.PromptInitMessage.verify(message.promptInit);
                if (error)
                    return "promptInit." + error;
            }
        }
        if (message.init != null && message.hasOwnProperty("init")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.InitMessage.verify(message.init);
                if (error)
                    return "init." + error;
            }
        }
        if (message.update != null && message.hasOwnProperty("update")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.UpdateMessage.verify(message.update);
                if (error)
                    return "update." + error;
            }
        }
        if (message.updatePresence != null && message.hasOwnProperty("updatePresence")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.UpdatePresenceMessage.verify(message.updatePresence);
                if (error)
                    return "updatePresence." + error;
            }
        }
        if (message.broadcastPresences != null && message.hasOwnProperty("broadcastPresences")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.BroadcastPresencesMessage.verify(message.broadcastPresences);
                if (error)
                    return "broadcastPresences." + error;
            }
        }
        if (message.broadcastOperation != null && message.hasOwnProperty("broadcastOperation")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.BroadcastOperationMessage.verify(message.broadcastOperation);
                if (error)
                    return "broadcastOperation." + error;
            }
        }
        if (message.ack != null && message.hasOwnProperty("ack")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.AckMessage.verify(message.ack);
                if (error)
                    return "ack." + error;
            }
        }
        if (message.rpcRequest != null && message.hasOwnProperty("rpcRequest")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.RPCRequestMessage.verify(message.rpcRequest);
                if (error)
                    return "rpcRequest." + error;
            }
        }
        if (message.rpcReply != null && message.hasOwnProperty("rpcReply")) {
            if (properties.message === 1)
                return "message: multiple values";
            properties.message = 1;
            {
                let error = $root.RPCReplyMessage.verify(message.rpcReply);
                if (error)
                    return "rpcReply." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Message message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Message
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Message} Message
     */
    Message.fromObject = function fromObject(object) {
        if (object instanceof $root.Message)
            return object;
        let message = new $root.Message();
        if (object.promptInit != null) {
            if (typeof object.promptInit !== "object")
                throw TypeError(".Message.promptInit: object expected");
            message.promptInit = $root.PromptInitMessage.fromObject(object.promptInit);
        }
        if (object.init != null) {
            if (typeof object.init !== "object")
                throw TypeError(".Message.init: object expected");
            message.init = $root.InitMessage.fromObject(object.init);
        }
        if (object.update != null) {
            if (typeof object.update !== "object")
                throw TypeError(".Message.update: object expected");
            message.update = $root.UpdateMessage.fromObject(object.update);
        }
        if (object.updatePresence != null) {
            if (typeof object.updatePresence !== "object")
                throw TypeError(".Message.updatePresence: object expected");
            message.updatePresence = $root.UpdatePresenceMessage.fromObject(object.updatePresence);
        }
        if (object.broadcastPresences != null) {
            if (typeof object.broadcastPresences !== "object")
                throw TypeError(".Message.broadcastPresences: object expected");
            message.broadcastPresences = $root.BroadcastPresencesMessage.fromObject(object.broadcastPresences);
        }
        if (object.broadcastOperation != null) {
            if (typeof object.broadcastOperation !== "object")
                throw TypeError(".Message.broadcastOperation: object expected");
            message.broadcastOperation = $root.BroadcastOperationMessage.fromObject(object.broadcastOperation);
        }
        if (object.ack != null) {
            if (typeof object.ack !== "object")
                throw TypeError(".Message.ack: object expected");
            message.ack = $root.AckMessage.fromObject(object.ack);
        }
        if (object.rpcRequest != null) {
            if (typeof object.rpcRequest !== "object")
                throw TypeError(".Message.rpcRequest: object expected");
            message.rpcRequest = $root.RPCRequestMessage.fromObject(object.rpcRequest);
        }
        if (object.rpcReply != null) {
            if (typeof object.rpcReply !== "object")
                throw TypeError(".Message.rpcReply: object expected");
            message.rpcReply = $root.RPCReplyMessage.fromObject(object.rpcReply);
        }
        return message;
    };

    /**
     * Creates a plain object from a Message message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Message
     * @static
     * @param {Message} message Message
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Message.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.promptInit != null && message.hasOwnProperty("promptInit")) {
            object.promptInit = $root.PromptInitMessage.toObject(message.promptInit, options);
            if (options.oneofs)
                object.message = "promptInit";
        }
        if (message.init != null && message.hasOwnProperty("init")) {
            object.init = $root.InitMessage.toObject(message.init, options);
            if (options.oneofs)
                object.message = "init";
        }
        if (message.update != null && message.hasOwnProperty("update")) {
            object.update = $root.UpdateMessage.toObject(message.update, options);
            if (options.oneofs)
                object.message = "update";
        }
        if (message.updatePresence != null && message.hasOwnProperty("updatePresence")) {
            object.updatePresence = $root.UpdatePresenceMessage.toObject(message.updatePresence, options);
            if (options.oneofs)
                object.message = "updatePresence";
        }
        if (message.broadcastPresences != null && message.hasOwnProperty("broadcastPresences")) {
            object.broadcastPresences = $root.BroadcastPresencesMessage.toObject(message.broadcastPresences, options);
            if (options.oneofs)
                object.message = "broadcastPresences";
        }
        if (message.broadcastOperation != null && message.hasOwnProperty("broadcastOperation")) {
            object.broadcastOperation = $root.BroadcastOperationMessage.toObject(message.broadcastOperation, options);
            if (options.oneofs)
                object.message = "broadcastOperation";
        }
        if (message.ack != null && message.hasOwnProperty("ack")) {
            object.ack = $root.AckMessage.toObject(message.ack, options);
            if (options.oneofs)
                object.message = "ack";
        }
        if (message.rpcRequest != null && message.hasOwnProperty("rpcRequest")) {
            object.rpcRequest = $root.RPCRequestMessage.toObject(message.rpcRequest, options);
            if (options.oneofs)
                object.message = "rpcRequest";
        }
        if (message.rpcReply != null && message.hasOwnProperty("rpcReply")) {
            object.rpcReply = $root.RPCReplyMessage.toObject(message.rpcReply, options);
            if (options.oneofs)
                object.message = "rpcReply";
        }
        return object;
    };

    /**
     * Converts this Message to JSON.
     * @function toJSON
     * @memberof Message
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Message.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Message
     * @function getTypeUrl
     * @memberof Message
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Message.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Message";
    };

    return Message;
})();

export const Presence = $root.Presence = (() => {

    /**
     * Properties of a Presence.
     * @exports IPresence
     * @interface IPresence
     * @property {Object.<string,string>|null} [data] Presence data
     * @property {number|Long} joinTimestamp Presence joinTimestamp
     * @property {number|Long} updateTimestamp Presence updateTimestamp
     * @property {string} clientId Presence clientId
     * @property {Object.<string,Uint8Array>|null} [positions] Presence positions
     */

    /**
     * Constructs a new Presence.
     * @exports Presence
     * @classdesc Represents a Presence.
     * @implements IPresence
     * @constructor
     * @param {IPresence=} [properties] Properties to set
     */
    function Presence(properties) {
        this.data = {};
        this.positions = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Presence data.
     * @member {Object.<string,string>} data
     * @memberof Presence
     * @instance
     */
    Presence.prototype.data = $util.emptyObject;

    /**
     * Presence joinTimestamp.
     * @member {number|Long} joinTimestamp
     * @memberof Presence
     * @instance
     */
    Presence.prototype.joinTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Presence updateTimestamp.
     * @member {number|Long} updateTimestamp
     * @memberof Presence
     * @instance
     */
    Presence.prototype.updateTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Presence clientId.
     * @member {string} clientId
     * @memberof Presence
     * @instance
     */
    Presence.prototype.clientId = "";

    /**
     * Presence positions.
     * @member {Object.<string,Uint8Array>} positions
     * @memberof Presence
     * @instance
     */
    Presence.prototype.positions = $util.emptyObject;

    /**
     * Creates a new Presence instance using the specified properties.
     * @function create
     * @memberof Presence
     * @static
     * @param {IPresence=} [properties] Properties to set
     * @returns {Presence} Presence instance
     */
    Presence.create = function create(properties) {
        return new Presence(properties);
    };

    /**
     * Encodes the specified Presence message. Does not implicitly {@link Presence.verify|verify} messages.
     * @function encode
     * @memberof Presence
     * @static
     * @param {IPresence} message Presence message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Presence.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            for (let keys = Object.keys(message.data), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.data[keys[i]]).ldelim();
        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.joinTimestamp);
        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.updateTimestamp);
        writer.uint32(/* id 4, wireType 2 =*/34).string(message.clientId);
        if (message.positions != null && Object.hasOwnProperty.call(message, "positions"))
            for (let keys = Object.keys(message.positions), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).bytes(message.positions[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Presence message, length delimited. Does not implicitly {@link Presence.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Presence
     * @static
     * @param {IPresence} message Presence message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Presence.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Presence message from the specified reader or buffer.
     * @function decode
     * @memberof Presence
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Presence} Presence
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Presence.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Presence(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (message.data === $util.emptyObject)
                        message.data = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7);
                            break;
                        }
                    }
                    message.data[key] = value;
                    break;
                }
            case 2: {
                    message.joinTimestamp = reader.int64();
                    break;
                }
            case 3: {
                    message.updateTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.clientId = reader.string();
                    break;
                }
            case 5: {
                    if (message.positions === $util.emptyObject)
                        message.positions = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = [];
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag2 & 7);
                            break;
                        }
                    }
                    message.positions[key] = value;
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("joinTimestamp"))
            throw $util.ProtocolError("missing required 'joinTimestamp'", { instance: message });
        if (!message.hasOwnProperty("updateTimestamp"))
            throw $util.ProtocolError("missing required 'updateTimestamp'", { instance: message });
        if (!message.hasOwnProperty("clientId"))
            throw $util.ProtocolError("missing required 'clientId'", { instance: message });
        return message;
    };

    /**
     * Decodes a Presence message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Presence
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Presence} Presence
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Presence.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Presence message.
     * @function verify
     * @memberof Presence
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Presence.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data")) {
            if (!$util.isObject(message.data))
                return "data: object expected";
            let key = Object.keys(message.data);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.data[key[i]]))
                    return "data: string{k:string} expected";
        }
        if (!$util.isInteger(message.joinTimestamp) && !(message.joinTimestamp && $util.isInteger(message.joinTimestamp.low) && $util.isInteger(message.joinTimestamp.high)))
            return "joinTimestamp: integer|Long expected";
        if (!$util.isInteger(message.updateTimestamp) && !(message.updateTimestamp && $util.isInteger(message.updateTimestamp.low) && $util.isInteger(message.updateTimestamp.high)))
            return "updateTimestamp: integer|Long expected";
        if (!$util.isString(message.clientId))
            return "clientId: string expected";
        if (message.positions != null && message.hasOwnProperty("positions")) {
            if (!$util.isObject(message.positions))
                return "positions: object expected";
            let key = Object.keys(message.positions);
            for (let i = 0; i < key.length; ++i)
                if (!(message.positions[key[i]] && typeof message.positions[key[i]].length === "number" || $util.isString(message.positions[key[i]])))
                    return "positions: buffer{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a Presence message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Presence
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Presence} Presence
     */
    Presence.fromObject = function fromObject(object) {
        if (object instanceof $root.Presence)
            return object;
        let message = new $root.Presence();
        if (object.data) {
            if (typeof object.data !== "object")
                throw TypeError(".Presence.data: object expected");
            message.data = {};
            for (let keys = Object.keys(object.data), i = 0; i < keys.length; ++i)
                message.data[keys[i]] = String(object.data[keys[i]]);
        }
        if (object.joinTimestamp != null)
            if ($util.Long)
                (message.joinTimestamp = $util.Long.fromValue(object.joinTimestamp)).unsigned = false;
            else if (typeof object.joinTimestamp === "string")
                message.joinTimestamp = parseInt(object.joinTimestamp, 10);
            else if (typeof object.joinTimestamp === "number")
                message.joinTimestamp = object.joinTimestamp;
            else if (typeof object.joinTimestamp === "object")
                message.joinTimestamp = new $util.LongBits(object.joinTimestamp.low >>> 0, object.joinTimestamp.high >>> 0).toNumber();
        if (object.updateTimestamp != null)
            if ($util.Long)
                (message.updateTimestamp = $util.Long.fromValue(object.updateTimestamp)).unsigned = false;
            else if (typeof object.updateTimestamp === "string")
                message.updateTimestamp = parseInt(object.updateTimestamp, 10);
            else if (typeof object.updateTimestamp === "number")
                message.updateTimestamp = object.updateTimestamp;
            else if (typeof object.updateTimestamp === "object")
                message.updateTimestamp = new $util.LongBits(object.updateTimestamp.low >>> 0, object.updateTimestamp.high >>> 0).toNumber();
        if (object.clientId != null)
            message.clientId = String(object.clientId);
        if (object.positions) {
            if (typeof object.positions !== "object")
                throw TypeError(".Presence.positions: object expected");
            message.positions = {};
            for (let keys = Object.keys(object.positions), i = 0; i < keys.length; ++i)
                if (typeof object.positions[keys[i]] === "string")
                    $util.base64.decode(object.positions[keys[i]], message.positions[keys[i]] = $util.newBuffer($util.base64.length(object.positions[keys[i]])), 0);
                else if (object.positions[keys[i]].length >= 0)
                    message.positions[keys[i]] = object.positions[keys[i]];
        }
        return message;
    };

    /**
     * Creates a plain object from a Presence message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Presence
     * @static
     * @param {Presence} message Presence
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Presence.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults) {
            object.data = {};
            object.positions = {};
        }
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.joinTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.joinTimestamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.updateTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.updateTimestamp = options.longs === String ? "0" : 0;
            object.clientId = "";
        }
        let keys2;
        if (message.data && (keys2 = Object.keys(message.data)).length) {
            object.data = {};
            for (let j = 0; j < keys2.length; ++j)
                object.data[keys2[j]] = message.data[keys2[j]];
        }
        if (message.joinTimestamp != null && message.hasOwnProperty("joinTimestamp"))
            if (typeof message.joinTimestamp === "number")
                object.joinTimestamp = options.longs === String ? String(message.joinTimestamp) : message.joinTimestamp;
            else
                object.joinTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.joinTimestamp) : options.longs === Number ? new $util.LongBits(message.joinTimestamp.low >>> 0, message.joinTimestamp.high >>> 0).toNumber() : message.joinTimestamp;
        if (message.updateTimestamp != null && message.hasOwnProperty("updateTimestamp"))
            if (typeof message.updateTimestamp === "number")
                object.updateTimestamp = options.longs === String ? String(message.updateTimestamp) : message.updateTimestamp;
            else
                object.updateTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimestamp) : options.longs === Number ? new $util.LongBits(message.updateTimestamp.low >>> 0, message.updateTimestamp.high >>> 0).toNumber() : message.updateTimestamp;
        if (message.clientId != null && message.hasOwnProperty("clientId"))
            object.clientId = message.clientId;
        if (message.positions && (keys2 = Object.keys(message.positions)).length) {
            object.positions = {};
            for (let j = 0; j < keys2.length; ++j)
                object.positions[keys2[j]] = options.bytes === String ? $util.base64.encode(message.positions[keys2[j]], 0, message.positions[keys2[j]].length) : options.bytes === Array ? Array.prototype.slice.call(message.positions[keys2[j]]) : message.positions[keys2[j]];
        }
        return object;
    };

    /**
     * Converts this Presence to JSON.
     * @function toJSON
     * @memberof Presence
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Presence.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for Presence
     * @function getTypeUrl
     * @memberof Presence
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    Presence.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/Presence";
    };

    return Presence;
})();

export const ContentOperation = $root.ContentOperation = (() => {

    /**
     * Properties of a ContentOperation.
     * @exports IContentOperation
     * @interface IContentOperation
     * @property {string} id ContentOperation id
     * @property {ContentOperationStatus} status ContentOperation status
     * @property {number|Long} createdAt ContentOperation createdAt
     * @property {number|Long} updatedAt ContentOperation updatedAt
     * @property {number} updateId ContentOperation updateId
     * @property {number} expireAfter ContentOperation expireAfter
     * @property {number} cursor ContentOperation cursor
     * @property {number} target ContentOperation target
     * @property {Object.<string,string>|null} [payload] ContentOperation payload
     */

    /**
     * Constructs a new ContentOperation.
     * @exports ContentOperation
     * @classdesc Represents a ContentOperation.
     * @implements IContentOperation
     * @constructor
     * @param {IContentOperation=} [properties] Properties to set
     */
    function ContentOperation(properties) {
        this.payload = {};
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ContentOperation id.
     * @member {string} id
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.id = "";

    /**
     * ContentOperation status.
     * @member {ContentOperationStatus} status
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.status = 0;

    /**
     * ContentOperation createdAt.
     * @member {number|Long} createdAt
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ContentOperation updatedAt.
     * @member {number|Long} updatedAt
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ContentOperation updateId.
     * @member {number} updateId
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.updateId = 0;

    /**
     * ContentOperation expireAfter.
     * @member {number} expireAfter
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.expireAfter = 0;

    /**
     * ContentOperation cursor.
     * @member {number} cursor
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.cursor = 0;

    /**
     * ContentOperation target.
     * @member {number} target
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.target = 0;

    /**
     * ContentOperation payload.
     * @member {Object.<string,string>} payload
     * @memberof ContentOperation
     * @instance
     */
    ContentOperation.prototype.payload = $util.emptyObject;

    /**
     * Creates a new ContentOperation instance using the specified properties.
     * @function create
     * @memberof ContentOperation
     * @static
     * @param {IContentOperation=} [properties] Properties to set
     * @returns {ContentOperation} ContentOperation instance
     */
    ContentOperation.create = function create(properties) {
        return new ContentOperation(properties);
    };

    /**
     * Encodes the specified ContentOperation message. Does not implicitly {@link ContentOperation.verify|verify} messages.
     * @function encode
     * @memberof ContentOperation
     * @static
     * @param {IContentOperation} message ContentOperation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentOperation.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createdAt);
        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.updatedAt);
        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.updateId);
        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.expireAfter);
        writer.uint32(/* id 7, wireType 0 =*/56).int32(message.cursor);
        writer.uint32(/* id 8, wireType 0 =*/64).int32(message.target);
        if (message.payload != null && Object.hasOwnProperty.call(message, "payload"))
            for (let keys = Object.keys(message.payload), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 9, wireType 2 =*/74).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.payload[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ContentOperation message, length delimited. Does not implicitly {@link ContentOperation.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ContentOperation
     * @static
     * @param {IContentOperation} message ContentOperation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ContentOperation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ContentOperation message from the specified reader or buffer.
     * @function decode
     * @memberof ContentOperation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ContentOperation} ContentOperation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentOperation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ContentOperation(), key, value;
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.status = reader.int32();
                    break;
                }
            case 3: {
                    message.createdAt = reader.int64();
                    break;
                }
            case 4: {
                    message.updatedAt = reader.int64();
                    break;
                }
            case 5: {
                    message.updateId = reader.int32();
                    break;
                }
            case 6: {
                    message.expireAfter = reader.int32();
                    break;
                }
            case 7: {
                    message.cursor = reader.int32();
                    break;
                }
            case 8: {
                    message.target = reader.int32();
                    break;
                }
            case 9: {
                    if (message.payload === $util.emptyObject)
                        message.payload = {};
                    let end2 = reader.uint32() + reader.pos;
                    key = "";
                    value = "";
                    while (reader.pos < end2) {
                        let tag2 = reader.uint32();
                        switch (tag2 >>> 3) {
                        case 1:
                            key = reader.string();
                            break;
                        case 2:
                            value = reader.string();
                            break;
                        default:
                            reader.skipType(tag2 & 7);
                            break;
                        }
                    }
                    message.payload[key] = value;
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("status"))
            throw $util.ProtocolError("missing required 'status'", { instance: message });
        if (!message.hasOwnProperty("createdAt"))
            throw $util.ProtocolError("missing required 'createdAt'", { instance: message });
        if (!message.hasOwnProperty("updatedAt"))
            throw $util.ProtocolError("missing required 'updatedAt'", { instance: message });
        if (!message.hasOwnProperty("updateId"))
            throw $util.ProtocolError("missing required 'updateId'", { instance: message });
        if (!message.hasOwnProperty("expireAfter"))
            throw $util.ProtocolError("missing required 'expireAfter'", { instance: message });
        if (!message.hasOwnProperty("cursor"))
            throw $util.ProtocolError("missing required 'cursor'", { instance: message });
        if (!message.hasOwnProperty("target"))
            throw $util.ProtocolError("missing required 'target'", { instance: message });
        return message;
    };

    /**
     * Decodes a ContentOperation message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ContentOperation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ContentOperation} ContentOperation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ContentOperation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ContentOperation message.
     * @function verify
     * @memberof ContentOperation
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ContentOperation.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.id))
            return "id: string expected";
        switch (message.status) {
        default:
            return "status: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
            break;
        }
        if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
            return "createdAt: integer|Long expected";
        if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
            return "updatedAt: integer|Long expected";
        if (!$util.isInteger(message.updateId))
            return "updateId: integer expected";
        if (!$util.isInteger(message.expireAfter))
            return "expireAfter: integer expected";
        if (!$util.isInteger(message.cursor))
            return "cursor: integer expected";
        if (!$util.isInteger(message.target))
            return "target: integer expected";
        if (message.payload != null && message.hasOwnProperty("payload")) {
            if (!$util.isObject(message.payload))
                return "payload: object expected";
            let key = Object.keys(message.payload);
            for (let i = 0; i < key.length; ++i)
                if (!$util.isString(message.payload[key[i]]))
                    return "payload: string{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a ContentOperation message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ContentOperation
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ContentOperation} ContentOperation
     */
    ContentOperation.fromObject = function fromObject(object) {
        if (object instanceof $root.ContentOperation)
            return object;
        let message = new $root.ContentOperation();
        if (object.id != null)
            message.id = String(object.id);
        switch (object.status) {
        default:
            if (typeof object.status === "number") {
                message.status = object.status;
                break;
            }
            break;
        case "STARTING":
        case 0:
            message.status = 0;
            break;
        case "RUNNING":
        case 1:
            message.status = 1;
            break;
        case "SUCCESS":
        case 2:
            message.status = 2;
            break;
        case "ERROR":
        case 3:
            message.status = 3;
            break;
        }
        if (object.createdAt != null)
            if ($util.Long)
                (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
            else if (typeof object.createdAt === "string")
                message.createdAt = parseInt(object.createdAt, 10);
            else if (typeof object.createdAt === "number")
                message.createdAt = object.createdAt;
            else if (typeof object.createdAt === "object")
                message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
        if (object.updatedAt != null)
            if ($util.Long)
                (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
            else if (typeof object.updatedAt === "string")
                message.updatedAt = parseInt(object.updatedAt, 10);
            else if (typeof object.updatedAt === "number")
                message.updatedAt = object.updatedAt;
            else if (typeof object.updatedAt === "object")
                message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
        if (object.updateId != null)
            message.updateId = object.updateId | 0;
        if (object.expireAfter != null)
            message.expireAfter = object.expireAfter | 0;
        if (object.cursor != null)
            message.cursor = object.cursor | 0;
        if (object.target != null)
            message.target = object.target | 0;
        if (object.payload) {
            if (typeof object.payload !== "object")
                throw TypeError(".ContentOperation.payload: object expected");
            message.payload = {};
            for (let keys = Object.keys(object.payload), i = 0; i < keys.length; ++i)
                message.payload[keys[i]] = String(object.payload[keys[i]]);
        }
        return message;
    };

    /**
     * Creates a plain object from a ContentOperation message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ContentOperation
     * @static
     * @param {ContentOperation} message ContentOperation
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ContentOperation.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.objects || options.defaults)
            object.payload = {};
        if (options.defaults) {
            object.id = "";
            object.status = options.enums === String ? "STARTING" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.createdAt = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.updatedAt = options.longs === String ? "0" : 0;
            object.updateId = 0;
            object.expireAfter = 0;
            object.cursor = 0;
            object.target = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.ContentOperationStatus[message.status] === undefined ? message.status : $root.ContentOperationStatus[message.status] : message.status;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (typeof message.createdAt === "number")
                object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
            else
                object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
        if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
            if (typeof message.updatedAt === "number")
                object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
            else
                object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
        if (message.updateId != null && message.hasOwnProperty("updateId"))
            object.updateId = message.updateId;
        if (message.expireAfter != null && message.hasOwnProperty("expireAfter"))
            object.expireAfter = message.expireAfter;
        if (message.cursor != null && message.hasOwnProperty("cursor"))
            object.cursor = message.cursor;
        if (message.target != null && message.hasOwnProperty("target"))
            object.target = message.target;
        let keys2;
        if (message.payload && (keys2 = Object.keys(message.payload)).length) {
            object.payload = {};
            for (let j = 0; j < keys2.length; ++j)
                object.payload[keys2[j]] = message.payload[keys2[j]];
        }
        return object;
    };

    /**
     * Converts this ContentOperation to JSON.
     * @function toJSON
     * @memberof ContentOperation
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ContentOperation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ContentOperation
     * @function getTypeUrl
     * @memberof ContentOperation
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ContentOperation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ContentOperation";
    };

    return ContentOperation;
})();

export const DebugLog = $root.DebugLog = (() => {

    /**
     * Properties of a DebugLog.
     * @exports IDebugLog
     * @interface IDebugLog
     * @property {Array.<IDebugLogUpdate>|null} [updates] DebugLog updates
     */

    /**
     * Constructs a new DebugLog.
     * @exports DebugLog
     * @classdesc Represents a DebugLog.
     * @implements IDebugLog
     * @constructor
     * @param {IDebugLog=} [properties] Properties to set
     */
    function DebugLog(properties) {
        this.updates = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DebugLog updates.
     * @member {Array.<IDebugLogUpdate>} updates
     * @memberof DebugLog
     * @instance
     */
    DebugLog.prototype.updates = $util.emptyArray;

    /**
     * Creates a new DebugLog instance using the specified properties.
     * @function create
     * @memberof DebugLog
     * @static
     * @param {IDebugLog=} [properties] Properties to set
     * @returns {DebugLog} DebugLog instance
     */
    DebugLog.create = function create(properties) {
        return new DebugLog(properties);
    };

    /**
     * Encodes the specified DebugLog message. Does not implicitly {@link DebugLog.verify|verify} messages.
     * @function encode
     * @memberof DebugLog
     * @static
     * @param {IDebugLog} message DebugLog message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugLog.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.updates != null && message.updates.length)
            for (let i = 0; i < message.updates.length; ++i)
                $root.DebugLogUpdate.encode(message.updates[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DebugLog message, length delimited. Does not implicitly {@link DebugLog.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DebugLog
     * @static
     * @param {IDebugLog} message DebugLog message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugLog.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DebugLog message from the specified reader or buffer.
     * @function decode
     * @memberof DebugLog
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DebugLog} DebugLog
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugLog.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLog();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.updates && message.updates.length))
                        message.updates = [];
                    message.updates.push($root.DebugLogUpdate.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DebugLog message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DebugLog
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DebugLog} DebugLog
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugLog.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DebugLog message.
     * @function verify
     * @memberof DebugLog
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DebugLog.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.updates != null && message.hasOwnProperty("updates")) {
            if (!Array.isArray(message.updates))
                return "updates: array expected";
            for (let i = 0; i < message.updates.length; ++i) {
                let error = $root.DebugLogUpdate.verify(message.updates[i]);
                if (error)
                    return "updates." + error;
            }
        }
        return null;
    };

    /**
     * Creates a DebugLog message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DebugLog
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DebugLog} DebugLog
     */
    DebugLog.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLog)
            return object;
        let message = new $root.DebugLog();
        if (object.updates) {
            if (!Array.isArray(object.updates))
                throw TypeError(".DebugLog.updates: array expected");
            message.updates = [];
            for (let i = 0; i < object.updates.length; ++i) {
                if (typeof object.updates[i] !== "object")
                    throw TypeError(".DebugLog.updates: object expected");
                message.updates[i] = $root.DebugLogUpdate.fromObject(object.updates[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a DebugLog message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DebugLog
     * @static
     * @param {DebugLog} message DebugLog
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DebugLog.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.updates = [];
        if (message.updates && message.updates.length) {
            object.updates = [];
            for (let j = 0; j < message.updates.length; ++j)
                object.updates[j] = $root.DebugLogUpdate.toObject(message.updates[j], options);
        }
        return object;
    };

    /**
     * Converts this DebugLog to JSON.
     * @function toJSON
     * @memberof DebugLog
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DebugLog.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DebugLog
     * @function getTypeUrl
     * @memberof DebugLog
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DebugLog.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DebugLog";
    };

    return DebugLog;
})();

export const DebugLogUpdate = $root.DebugLogUpdate = (() => {

    /**
     * Properties of a DebugLogUpdate.
     * @exports IDebugLogUpdate
     * @interface IDebugLogUpdate
     * @property {number|Long} timestamp DebugLogUpdate timestamp
     * @property {Uint8Array} update DebugLogUpdate update
     * @property {string} origin DebugLogUpdate origin
     */

    /**
     * Constructs a new DebugLogUpdate.
     * @exports DebugLogUpdate
     * @classdesc Represents a DebugLogUpdate.
     * @implements IDebugLogUpdate
     * @constructor
     * @param {IDebugLogUpdate=} [properties] Properties to set
     */
    function DebugLogUpdate(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DebugLogUpdate timestamp.
     * @member {number|Long} timestamp
     * @memberof DebugLogUpdate
     * @instance
     */
    DebugLogUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * DebugLogUpdate update.
     * @member {Uint8Array} update
     * @memberof DebugLogUpdate
     * @instance
     */
    DebugLogUpdate.prototype.update = $util.newBuffer([]);

    /**
     * DebugLogUpdate origin.
     * @member {string} origin
     * @memberof DebugLogUpdate
     * @instance
     */
    DebugLogUpdate.prototype.origin = "";

    /**
     * Creates a new DebugLogUpdate instance using the specified properties.
     * @function create
     * @memberof DebugLogUpdate
     * @static
     * @param {IDebugLogUpdate=} [properties] Properties to set
     * @returns {DebugLogUpdate} DebugLogUpdate instance
     */
    DebugLogUpdate.create = function create(properties) {
        return new DebugLogUpdate(properties);
    };

    /**
     * Encodes the specified DebugLogUpdate message. Does not implicitly {@link DebugLogUpdate.verify|verify} messages.
     * @function encode
     * @memberof DebugLogUpdate
     * @static
     * @param {IDebugLogUpdate} message DebugLogUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugLogUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.timestamp);
        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.update);
        writer.uint32(/* id 3, wireType 2 =*/26).string(message.origin);
        return writer;
    };

    /**
     * Encodes the specified DebugLogUpdate message, length delimited. Does not implicitly {@link DebugLogUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DebugLogUpdate
     * @static
     * @param {IDebugLogUpdate} message DebugLogUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugLogUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DebugLogUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof DebugLogUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DebugLogUpdate} DebugLogUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugLogUpdate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugLogUpdate();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.timestamp = reader.int64();
                    break;
                }
            case 2: {
                    message.update = reader.bytes();
                    break;
                }
            case 3: {
                    message.origin = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("timestamp"))
            throw $util.ProtocolError("missing required 'timestamp'", { instance: message });
        if (!message.hasOwnProperty("update"))
            throw $util.ProtocolError("missing required 'update'", { instance: message });
        if (!message.hasOwnProperty("origin"))
            throw $util.ProtocolError("missing required 'origin'", { instance: message });
        return message;
    };

    /**
     * Decodes a DebugLogUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DebugLogUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DebugLogUpdate} DebugLogUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugLogUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DebugLogUpdate message.
     * @function verify
     * @memberof DebugLogUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DebugLogUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
            return "timestamp: integer|Long expected";
        if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
            return "update: buffer expected";
        if (!$util.isString(message.origin))
            return "origin: string expected";
        return null;
    };

    /**
     * Creates a DebugLogUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DebugLogUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DebugLogUpdate} DebugLogUpdate
     */
    DebugLogUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugLogUpdate)
            return object;
        let message = new $root.DebugLogUpdate();
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length >= 0)
                message.update = object.update;
        if (object.origin != null)
            message.origin = String(object.origin);
        return message;
    };

    /**
     * Creates a plain object from a DebugLogUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DebugLogUpdate
     * @static
     * @param {DebugLogUpdate} message DebugLogUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DebugLogUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.update = "";
            else {
                object.update = [];
                if (options.bytes !== Array)
                    object.update = $util.newBuffer(object.update);
            }
            object.origin = "";
        }
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
        if (message.update != null && message.hasOwnProperty("update"))
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
        if (message.origin != null && message.hasOwnProperty("origin"))
            object.origin = message.origin;
        return object;
    };

    /**
     * Converts this DebugLogUpdate to JSON.
     * @function toJSON
     * @memberof DebugLogUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DebugLogUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DebugLogUpdate
     * @function getTypeUrl
     * @memberof DebugLogUpdate
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DebugLogUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DebugLogUpdate";
    };

    return DebugLogUpdate;
})();

export const DocumentCompletions = $root.DocumentCompletions = (() => {

    /**
     * Constructs a new DocumentCompletions service.
     * @exports DocumentCompletions
     * @classdesc Represents a DocumentCompletions
     * @extends $protobuf.rpc.Service
     * @constructor
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     */
    function DocumentCompletions(rpcImpl, requestDelimited, responseDelimited) {
        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
    }

    (DocumentCompletions.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = DocumentCompletions;

    /**
     * Creates new DocumentCompletions service using the specified rpc implementation.
     * @function create
     * @memberof DocumentCompletions
     * @static
     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
     * @returns {DocumentCompletions} RPC service. Useful where requests and/or responses are streamed.
     */
    DocumentCompletions.create = function create(rpcImpl, requestDelimited, responseDelimited) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
    };

    /**
     * Callback as used by {@link DocumentCompletions#generateBlockCompletion}.
     * @memberof DocumentCompletions
     * @typedef generateBlockCompletionCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {GenerateBlockCompletionReply} [response] GenerateBlockCompletionReply
     */

    /**
     * Request to generate a completion for a block.
     * @function generateBlockCompletion
     * @memberof DocumentCompletions
     * @instance
     * @param {IGenerateBlockCompletionRequest} request GenerateBlockCompletionRequest message or plain object
     * @param {DocumentCompletions.generateBlockCompletionCallback} callback Node-style callback called with the error, if any, and GenerateBlockCompletionReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(DocumentCompletions.prototype.generateBlockCompletion = function generateBlockCompletion(request, callback) {
        return this.rpcCall(generateBlockCompletion, $root.GenerateBlockCompletionRequest, $root.GenerateBlockCompletionReply, request, callback);
    }, "name", { value: "generateBlockCompletion" });

    /**
     * Request to generate a completion for a block.
     * @function generateBlockCompletion
     * @memberof DocumentCompletions
     * @instance
     * @param {IGenerateBlockCompletionRequest} request GenerateBlockCompletionRequest message or plain object
     * @returns {Promise<GenerateBlockCompletionReply>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link DocumentCompletions#streamAICompletion}.
     * @memberof DocumentCompletions
     * @typedef streamAICompletionCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {AICompletionReply} [response] AICompletionReply
     */

    /**
     * Generate AI completion using a stream.
     * @function streamAICompletion
     * @memberof DocumentCompletions
     * @instance
     * @param {IAICompletionRequest} request AICompletionRequest message or plain object
     * @param {DocumentCompletions.streamAICompletionCallback} callback Node-style callback called with the error, if any, and AICompletionReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(DocumentCompletions.prototype.streamAICompletion = function streamAICompletion(request, callback) {
        return this.rpcCall(streamAICompletion, $root.AICompletionRequest, $root.AICompletionReply, request, callback);
    }, "name", { value: "streamAICompletion" });

    /**
     * Generate AI completion using a stream.
     * @function streamAICompletion
     * @memberof DocumentCompletions
     * @instance
     * @param {IAICompletionRequest} request AICompletionRequest message or plain object
     * @returns {Promise<AICompletionReply>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link DocumentCompletions#stopAICompletion}.
     * @memberof DocumentCompletions
     * @typedef stopAICompletionCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {StopAICompletionReply} [response] StopAICompletionReply
     */

    /**
     * Stop an AI completion.
     * @function stopAICompletion
     * @memberof DocumentCompletions
     * @instance
     * @param {IStopAICompletionRequest} request StopAICompletionRequest message or plain object
     * @param {DocumentCompletions.stopAICompletionCallback} callback Node-style callback called with the error, if any, and StopAICompletionReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(DocumentCompletions.prototype.stopAICompletion = function stopAICompletion(request, callback) {
        return this.rpcCall(stopAICompletion, $root.StopAICompletionRequest, $root.StopAICompletionReply, request, callback);
    }, "name", { value: "stopAICompletion" });

    /**
     * Stop an AI completion.
     * @function stopAICompletion
     * @memberof DocumentCompletions
     * @instance
     * @param {IStopAICompletionRequest} request StopAICompletionRequest message or plain object
     * @returns {Promise<StopAICompletionReply>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link DocumentCompletions#generateDiagramSuggestions}.
     * @memberof DocumentCompletions
     * @typedef generateDiagramSuggestionsCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {GenerateDiagramSuggestionsReply} [response] GenerateDiagramSuggestionsReply
     */

    /**
     * Request to generate suggestion of diagram prompts.
     * @function generateDiagramSuggestions
     * @memberof DocumentCompletions
     * @instance
     * @param {IGenerateDiagramSuggestionsRequest} request GenerateDiagramSuggestionsRequest message or plain object
     * @param {DocumentCompletions.generateDiagramSuggestionsCallback} callback Node-style callback called with the error, if any, and GenerateDiagramSuggestionsReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(DocumentCompletions.prototype.generateDiagramSuggestions = function generateDiagramSuggestions(request, callback) {
        return this.rpcCall(generateDiagramSuggestions, $root.GenerateDiagramSuggestionsRequest, $root.GenerateDiagramSuggestionsReply, request, callback);
    }, "name", { value: "generateDiagramSuggestions" });

    /**
     * Request to generate suggestion of diagram prompts.
     * @function generateDiagramSuggestions
     * @memberof DocumentCompletions
     * @instance
     * @param {IGenerateDiagramSuggestionsRequest} request GenerateDiagramSuggestionsRequest message or plain object
     * @returns {Promise<GenerateDiagramSuggestionsReply>} Promise
     * @variation 2
     */

    /**
     * Callback as used by {@link DocumentCompletions#generateDiagram}.
     * @memberof DocumentCompletions
     * @typedef generateDiagramCallback
     * @type {function}
     * @param {Error|null} error Error, if any
     * @param {GenerateDiagramReply} [response] GenerateDiagramReply
     */

    /**
     * Request to generate a diagram from a prompt.
     * @function generateDiagram
     * @memberof DocumentCompletions
     * @instance
     * @param {IGenerateDiagramRequest} request GenerateDiagramRequest message or plain object
     * @param {DocumentCompletions.generateDiagramCallback} callback Node-style callback called with the error, if any, and GenerateDiagramReply
     * @returns {undefined}
     * @variation 1
     */
    Object.defineProperty(DocumentCompletions.prototype.generateDiagram = function generateDiagram(request, callback) {
        return this.rpcCall(generateDiagram, $root.GenerateDiagramRequest, $root.GenerateDiagramReply, request, callback);
    }, "name", { value: "generateDiagram" });

    /**
     * Request to generate a diagram from a prompt.
     * @function generateDiagram
     * @memberof DocumentCompletions
     * @instance
     * @param {IGenerateDiagramRequest} request GenerateDiagramRequest message or plain object
     * @returns {Promise<GenerateDiagramReply>} Promise
     * @variation 2
     */

    return DocumentCompletions;
})();

export const StopAICompletionRequest = $root.StopAICompletionRequest = (() => {

    /**
     * Properties of a StopAICompletionRequest.
     * @exports IStopAICompletionRequest
     * @interface IStopAICompletionRequest
     * @property {string} id StopAICompletionRequest id
     */

    /**
     * Constructs a new StopAICompletionRequest.
     * @exports StopAICompletionRequest
     * @classdesc Represents a StopAICompletionRequest.
     * @implements IStopAICompletionRequest
     * @constructor
     * @param {IStopAICompletionRequest=} [properties] Properties to set
     */
    function StopAICompletionRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * StopAICompletionRequest id.
     * @member {string} id
     * @memberof StopAICompletionRequest
     * @instance
     */
    StopAICompletionRequest.prototype.id = "";

    /**
     * Creates a new StopAICompletionRequest instance using the specified properties.
     * @function create
     * @memberof StopAICompletionRequest
     * @static
     * @param {IStopAICompletionRequest=} [properties] Properties to set
     * @returns {StopAICompletionRequest} StopAICompletionRequest instance
     */
    StopAICompletionRequest.create = function create(properties) {
        return new StopAICompletionRequest(properties);
    };

    /**
     * Encodes the specified StopAICompletionRequest message. Does not implicitly {@link StopAICompletionRequest.verify|verify} messages.
     * @function encode
     * @memberof StopAICompletionRequest
     * @static
     * @param {IStopAICompletionRequest} message StopAICompletionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StopAICompletionRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        return writer;
    };

    /**
     * Encodes the specified StopAICompletionRequest message, length delimited. Does not implicitly {@link StopAICompletionRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StopAICompletionRequest
     * @static
     * @param {IStopAICompletionRequest} message StopAICompletionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StopAICompletionRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StopAICompletionRequest message from the specified reader or buffer.
     * @function decode
     * @memberof StopAICompletionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StopAICompletionRequest} StopAICompletionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StopAICompletionRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StopAICompletionRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        return message;
    };

    /**
     * Decodes a StopAICompletionRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StopAICompletionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StopAICompletionRequest} StopAICompletionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StopAICompletionRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StopAICompletionRequest message.
     * @function verify
     * @memberof StopAICompletionRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StopAICompletionRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.id))
            return "id: string expected";
        return null;
    };

    /**
     * Creates a StopAICompletionRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StopAICompletionRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StopAICompletionRequest} StopAICompletionRequest
     */
    StopAICompletionRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.StopAICompletionRequest)
            return object;
        let message = new $root.StopAICompletionRequest();
        if (object.id != null)
            message.id = String(object.id);
        return message;
    };

    /**
     * Creates a plain object from a StopAICompletionRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StopAICompletionRequest
     * @static
     * @param {StopAICompletionRequest} message StopAICompletionRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StopAICompletionRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.id = "";
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        return object;
    };

    /**
     * Converts this StopAICompletionRequest to JSON.
     * @function toJSON
     * @memberof StopAICompletionRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StopAICompletionRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for StopAICompletionRequest
     * @function getTypeUrl
     * @memberof StopAICompletionRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    StopAICompletionRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StopAICompletionRequest";
    };

    return StopAICompletionRequest;
})();

export const StopAICompletionReply = $root.StopAICompletionReply = (() => {

    /**
     * Properties of a StopAICompletionReply.
     * @exports IStopAICompletionReply
     * @interface IStopAICompletionReply
     */

    /**
     * Constructs a new StopAICompletionReply.
     * @exports StopAICompletionReply
     * @classdesc Represents a StopAICompletionReply.
     * @implements IStopAICompletionReply
     * @constructor
     * @param {IStopAICompletionReply=} [properties] Properties to set
     */
    function StopAICompletionReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new StopAICompletionReply instance using the specified properties.
     * @function create
     * @memberof StopAICompletionReply
     * @static
     * @param {IStopAICompletionReply=} [properties] Properties to set
     * @returns {StopAICompletionReply} StopAICompletionReply instance
     */
    StopAICompletionReply.create = function create(properties) {
        return new StopAICompletionReply(properties);
    };

    /**
     * Encodes the specified StopAICompletionReply message. Does not implicitly {@link StopAICompletionReply.verify|verify} messages.
     * @function encode
     * @memberof StopAICompletionReply
     * @static
     * @param {IStopAICompletionReply} message StopAICompletionReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StopAICompletionReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified StopAICompletionReply message, length delimited. Does not implicitly {@link StopAICompletionReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof StopAICompletionReply
     * @static
     * @param {IStopAICompletionReply} message StopAICompletionReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StopAICompletionReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a StopAICompletionReply message from the specified reader or buffer.
     * @function decode
     * @memberof StopAICompletionReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StopAICompletionReply} StopAICompletionReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StopAICompletionReply.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StopAICompletionReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a StopAICompletionReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof StopAICompletionReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {StopAICompletionReply} StopAICompletionReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StopAICompletionReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a StopAICompletionReply message.
     * @function verify
     * @memberof StopAICompletionReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    StopAICompletionReply.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a StopAICompletionReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StopAICompletionReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StopAICompletionReply} StopAICompletionReply
     */
    StopAICompletionReply.fromObject = function fromObject(object) {
        if (object instanceof $root.StopAICompletionReply)
            return object;
        return new $root.StopAICompletionReply();
    };

    /**
     * Creates a plain object from a StopAICompletionReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StopAICompletionReply
     * @static
     * @param {StopAICompletionReply} message StopAICompletionReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StopAICompletionReply.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this StopAICompletionReply to JSON.
     * @function toJSON
     * @memberof StopAICompletionReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StopAICompletionReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for StopAICompletionReply
     * @function getTypeUrl
     * @memberof StopAICompletionReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    StopAICompletionReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StopAICompletionReply";
    };

    return StopAICompletionReply;
})();

export const AICompletionRequest = $root.AICompletionRequest = (() => {

    /**
     * Properties of a AICompletionRequest.
     * @exports IAICompletionRequest
     * @interface IAICompletionRequest
     * @property {string} input AICompletionRequest input
     * @property {string} prompt AICompletionRequest prompt
     * @property {string} id AICompletionRequest id
     * @property {Array.<IAICompletionHistoryEntry>|null} [history] AICompletionRequest history
     */

    /**
     * Constructs a new AICompletionRequest.
     * @exports AICompletionRequest
     * @classdesc Represents a AICompletionRequest.
     * @implements IAICompletionRequest
     * @constructor
     * @param {IAICompletionRequest=} [properties] Properties to set
     */
    function AICompletionRequest(properties) {
        this.history = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AICompletionRequest input.
     * @member {string} input
     * @memberof AICompletionRequest
     * @instance
     */
    AICompletionRequest.prototype.input = "";

    /**
     * AICompletionRequest prompt.
     * @member {string} prompt
     * @memberof AICompletionRequest
     * @instance
     */
    AICompletionRequest.prototype.prompt = "";

    /**
     * AICompletionRequest id.
     * @member {string} id
     * @memberof AICompletionRequest
     * @instance
     */
    AICompletionRequest.prototype.id = "";

    /**
     * AICompletionRequest history.
     * @member {Array.<IAICompletionHistoryEntry>} history
     * @memberof AICompletionRequest
     * @instance
     */
    AICompletionRequest.prototype.history = $util.emptyArray;

    /**
     * Creates a new AICompletionRequest instance using the specified properties.
     * @function create
     * @memberof AICompletionRequest
     * @static
     * @param {IAICompletionRequest=} [properties] Properties to set
     * @returns {AICompletionRequest} AICompletionRequest instance
     */
    AICompletionRequest.create = function create(properties) {
        return new AICompletionRequest(properties);
    };

    /**
     * Encodes the specified AICompletionRequest message. Does not implicitly {@link AICompletionRequest.verify|verify} messages.
     * @function encode
     * @memberof AICompletionRequest
     * @static
     * @param {IAICompletionRequest} message AICompletionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AICompletionRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.input);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.prompt);
        writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
        if (message.history != null && message.history.length)
            for (let i = 0; i < message.history.length; ++i)
                $root.AICompletionHistoryEntry.encode(message.history[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AICompletionRequest message, length delimited. Does not implicitly {@link AICompletionRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AICompletionRequest
     * @static
     * @param {IAICompletionRequest} message AICompletionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AICompletionRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a AICompletionRequest message from the specified reader or buffer.
     * @function decode
     * @memberof AICompletionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AICompletionRequest} AICompletionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AICompletionRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AICompletionRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.input = reader.string();
                    break;
                }
            case 2: {
                    message.prompt = reader.string();
                    break;
                }
            case 3: {
                    message.id = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.history && message.history.length))
                        message.history = [];
                    message.history.push($root.AICompletionHistoryEntry.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("input"))
            throw $util.ProtocolError("missing required 'input'", { instance: message });
        if (!message.hasOwnProperty("prompt"))
            throw $util.ProtocolError("missing required 'prompt'", { instance: message });
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        return message;
    };

    /**
     * Decodes a AICompletionRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AICompletionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AICompletionRequest} AICompletionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AICompletionRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a AICompletionRequest message.
     * @function verify
     * @memberof AICompletionRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AICompletionRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.input))
            return "input: string expected";
        if (!$util.isString(message.prompt))
            return "prompt: string expected";
        if (!$util.isString(message.id))
            return "id: string expected";
        if (message.history != null && message.hasOwnProperty("history")) {
            if (!Array.isArray(message.history))
                return "history: array expected";
            for (let i = 0; i < message.history.length; ++i) {
                let error = $root.AICompletionHistoryEntry.verify(message.history[i]);
                if (error)
                    return "history." + error;
            }
        }
        return null;
    };

    /**
     * Creates a AICompletionRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AICompletionRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AICompletionRequest} AICompletionRequest
     */
    AICompletionRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AICompletionRequest)
            return object;
        let message = new $root.AICompletionRequest();
        if (object.input != null)
            message.input = String(object.input);
        if (object.prompt != null)
            message.prompt = String(object.prompt);
        if (object.id != null)
            message.id = String(object.id);
        if (object.history) {
            if (!Array.isArray(object.history))
                throw TypeError(".AICompletionRequest.history: array expected");
            message.history = [];
            for (let i = 0; i < object.history.length; ++i) {
                if (typeof object.history[i] !== "object")
                    throw TypeError(".AICompletionRequest.history: object expected");
                message.history[i] = $root.AICompletionHistoryEntry.fromObject(object.history[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a AICompletionRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AICompletionRequest
     * @static
     * @param {AICompletionRequest} message AICompletionRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AICompletionRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.history = [];
        if (options.defaults) {
            object.input = "";
            object.prompt = "";
            object.id = "";
        }
        if (message.input != null && message.hasOwnProperty("input"))
            object.input = message.input;
        if (message.prompt != null && message.hasOwnProperty("prompt"))
            object.prompt = message.prompt;
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.history && message.history.length) {
            object.history = [];
            for (let j = 0; j < message.history.length; ++j)
                object.history[j] = $root.AICompletionHistoryEntry.toObject(message.history[j], options);
        }
        return object;
    };

    /**
     * Converts this AICompletionRequest to JSON.
     * @function toJSON
     * @memberof AICompletionRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AICompletionRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AICompletionRequest
     * @function getTypeUrl
     * @memberof AICompletionRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AICompletionRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AICompletionRequest";
    };

    return AICompletionRequest;
})();

export const AICompletionReply = $root.AICompletionReply = (() => {

    /**
     * Properties of a AICompletionReply.
     * @exports IAICompletionReply
     * @interface IAICompletionReply
     * @property {string} completion AICompletionReply completion
     * @property {string} id AICompletionReply id
     */

    /**
     * Constructs a new AICompletionReply.
     * @exports AICompletionReply
     * @classdesc Represents a AICompletionReply.
     * @implements IAICompletionReply
     * @constructor
     * @param {IAICompletionReply=} [properties] Properties to set
     */
    function AICompletionReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AICompletionReply completion.
     * @member {string} completion
     * @memberof AICompletionReply
     * @instance
     */
    AICompletionReply.prototype.completion = "";

    /**
     * AICompletionReply id.
     * @member {string} id
     * @memberof AICompletionReply
     * @instance
     */
    AICompletionReply.prototype.id = "";

    /**
     * Creates a new AICompletionReply instance using the specified properties.
     * @function create
     * @memberof AICompletionReply
     * @static
     * @param {IAICompletionReply=} [properties] Properties to set
     * @returns {AICompletionReply} AICompletionReply instance
     */
    AICompletionReply.create = function create(properties) {
        return new AICompletionReply(properties);
    };

    /**
     * Encodes the specified AICompletionReply message. Does not implicitly {@link AICompletionReply.verify|verify} messages.
     * @function encode
     * @memberof AICompletionReply
     * @static
     * @param {IAICompletionReply} message AICompletionReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AICompletionReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.completion);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.id);
        return writer;
    };

    /**
     * Encodes the specified AICompletionReply message, length delimited. Does not implicitly {@link AICompletionReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AICompletionReply
     * @static
     * @param {IAICompletionReply} message AICompletionReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AICompletionReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a AICompletionReply message from the specified reader or buffer.
     * @function decode
     * @memberof AICompletionReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AICompletionReply} AICompletionReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AICompletionReply.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AICompletionReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.completion = reader.string();
                    break;
                }
            case 2: {
                    message.id = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("completion"))
            throw $util.ProtocolError("missing required 'completion'", { instance: message });
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        return message;
    };

    /**
     * Decodes a AICompletionReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AICompletionReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AICompletionReply} AICompletionReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AICompletionReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a AICompletionReply message.
     * @function verify
     * @memberof AICompletionReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AICompletionReply.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.completion))
            return "completion: string expected";
        if (!$util.isString(message.id))
            return "id: string expected";
        return null;
    };

    /**
     * Creates a AICompletionReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AICompletionReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AICompletionReply} AICompletionReply
     */
    AICompletionReply.fromObject = function fromObject(object) {
        if (object instanceof $root.AICompletionReply)
            return object;
        let message = new $root.AICompletionReply();
        if (object.completion != null)
            message.completion = String(object.completion);
        if (object.id != null)
            message.id = String(object.id);
        return message;
    };

    /**
     * Creates a plain object from a AICompletionReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AICompletionReply
     * @static
     * @param {AICompletionReply} message AICompletionReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AICompletionReply.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.completion = "";
            object.id = "";
        }
        if (message.completion != null && message.hasOwnProperty("completion"))
            object.completion = message.completion;
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        return object;
    };

    /**
     * Converts this AICompletionReply to JSON.
     * @function toJSON
     * @memberof AICompletionReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AICompletionReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AICompletionReply
     * @function getTypeUrl
     * @memberof AICompletionReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AICompletionReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AICompletionReply";
    };

    return AICompletionReply;
})();

export const AICompletionHistoryEntry = $root.AICompletionHistoryEntry = (() => {

    /**
     * Properties of a AICompletionHistoryEntry.
     * @exports IAICompletionHistoryEntry
     * @interface IAICompletionHistoryEntry
     * @property {string} prompt AICompletionHistoryEntry prompt
     * @property {string} answer AICompletionHistoryEntry answer
     */

    /**
     * Constructs a new AICompletionHistoryEntry.
     * @exports AICompletionHistoryEntry
     * @classdesc Represents a AICompletionHistoryEntry.
     * @implements IAICompletionHistoryEntry
     * @constructor
     * @param {IAICompletionHistoryEntry=} [properties] Properties to set
     */
    function AICompletionHistoryEntry(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AICompletionHistoryEntry prompt.
     * @member {string} prompt
     * @memberof AICompletionHistoryEntry
     * @instance
     */
    AICompletionHistoryEntry.prototype.prompt = "";

    /**
     * AICompletionHistoryEntry answer.
     * @member {string} answer
     * @memberof AICompletionHistoryEntry
     * @instance
     */
    AICompletionHistoryEntry.prototype.answer = "";

    /**
     * Creates a new AICompletionHistoryEntry instance using the specified properties.
     * @function create
     * @memberof AICompletionHistoryEntry
     * @static
     * @param {IAICompletionHistoryEntry=} [properties] Properties to set
     * @returns {AICompletionHistoryEntry} AICompletionHistoryEntry instance
     */
    AICompletionHistoryEntry.create = function create(properties) {
        return new AICompletionHistoryEntry(properties);
    };

    /**
     * Encodes the specified AICompletionHistoryEntry message. Does not implicitly {@link AICompletionHistoryEntry.verify|verify} messages.
     * @function encode
     * @memberof AICompletionHistoryEntry
     * @static
     * @param {IAICompletionHistoryEntry} message AICompletionHistoryEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AICompletionHistoryEntry.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.prompt);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.answer);
        return writer;
    };

    /**
     * Encodes the specified AICompletionHistoryEntry message, length delimited. Does not implicitly {@link AICompletionHistoryEntry.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AICompletionHistoryEntry
     * @static
     * @param {IAICompletionHistoryEntry} message AICompletionHistoryEntry message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AICompletionHistoryEntry.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a AICompletionHistoryEntry message from the specified reader or buffer.
     * @function decode
     * @memberof AICompletionHistoryEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AICompletionHistoryEntry} AICompletionHistoryEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AICompletionHistoryEntry.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AICompletionHistoryEntry();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.prompt = reader.string();
                    break;
                }
            case 2: {
                    message.answer = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("prompt"))
            throw $util.ProtocolError("missing required 'prompt'", { instance: message });
        if (!message.hasOwnProperty("answer"))
            throw $util.ProtocolError("missing required 'answer'", { instance: message });
        return message;
    };

    /**
     * Decodes a AICompletionHistoryEntry message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AICompletionHistoryEntry
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AICompletionHistoryEntry} AICompletionHistoryEntry
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AICompletionHistoryEntry.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a AICompletionHistoryEntry message.
     * @function verify
     * @memberof AICompletionHistoryEntry
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AICompletionHistoryEntry.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.prompt))
            return "prompt: string expected";
        if (!$util.isString(message.answer))
            return "answer: string expected";
        return null;
    };

    /**
     * Creates a AICompletionHistoryEntry message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AICompletionHistoryEntry
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AICompletionHistoryEntry} AICompletionHistoryEntry
     */
    AICompletionHistoryEntry.fromObject = function fromObject(object) {
        if (object instanceof $root.AICompletionHistoryEntry)
            return object;
        let message = new $root.AICompletionHistoryEntry();
        if (object.prompt != null)
            message.prompt = String(object.prompt);
        if (object.answer != null)
            message.answer = String(object.answer);
        return message;
    };

    /**
     * Creates a plain object from a AICompletionHistoryEntry message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AICompletionHistoryEntry
     * @static
     * @param {AICompletionHistoryEntry} message AICompletionHistoryEntry
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AICompletionHistoryEntry.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.prompt = "";
            object.answer = "";
        }
        if (message.prompt != null && message.hasOwnProperty("prompt"))
            object.prompt = message.prompt;
        if (message.answer != null && message.hasOwnProperty("answer"))
            object.answer = message.answer;
        return object;
    };

    /**
     * Converts this AICompletionHistoryEntry to JSON.
     * @function toJSON
     * @memberof AICompletionHistoryEntry
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AICompletionHistoryEntry.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AICompletionHistoryEntry
     * @function getTypeUrl
     * @memberof AICompletionHistoryEntry
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AICompletionHistoryEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AICompletionHistoryEntry";
    };

    return AICompletionHistoryEntry;
})();

export const GenerateBlockCompletionRequest = $root.GenerateBlockCompletionRequest = (() => {

    /**
     * Properties of a GenerateBlockCompletionRequest.
     * @exports IGenerateBlockCompletionRequest
     * @interface IGenerateBlockCompletionRequest
     * @property {string} startKey GenerateBlockCompletionRequest startKey
     * @property {string} endKey GenerateBlockCompletionRequest endKey
     * @property {string} prompt GenerateBlockCompletionRequest prompt
     * @property {string} id GenerateBlockCompletionRequest id
     * @property {Array.<IAICompletionHistoryEntry>|null} [history] GenerateBlockCompletionRequest history
     */

    /**
     * Constructs a new GenerateBlockCompletionRequest.
     * @exports GenerateBlockCompletionRequest
     * @classdesc Represents a GenerateBlockCompletionRequest.
     * @implements IGenerateBlockCompletionRequest
     * @constructor
     * @param {IGenerateBlockCompletionRequest=} [properties] Properties to set
     */
    function GenerateBlockCompletionRequest(properties) {
        this.history = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GenerateBlockCompletionRequest startKey.
     * @member {string} startKey
     * @memberof GenerateBlockCompletionRequest
     * @instance
     */
    GenerateBlockCompletionRequest.prototype.startKey = "";

    /**
     * GenerateBlockCompletionRequest endKey.
     * @member {string} endKey
     * @memberof GenerateBlockCompletionRequest
     * @instance
     */
    GenerateBlockCompletionRequest.prototype.endKey = "";

    /**
     * GenerateBlockCompletionRequest prompt.
     * @member {string} prompt
     * @memberof GenerateBlockCompletionRequest
     * @instance
     */
    GenerateBlockCompletionRequest.prototype.prompt = "";

    /**
     * GenerateBlockCompletionRequest id.
     * @member {string} id
     * @memberof GenerateBlockCompletionRequest
     * @instance
     */
    GenerateBlockCompletionRequest.prototype.id = "";

    /**
     * GenerateBlockCompletionRequest history.
     * @member {Array.<IAICompletionHistoryEntry>} history
     * @memberof GenerateBlockCompletionRequest
     * @instance
     */
    GenerateBlockCompletionRequest.prototype.history = $util.emptyArray;

    /**
     * Creates a new GenerateBlockCompletionRequest instance using the specified properties.
     * @function create
     * @memberof GenerateBlockCompletionRequest
     * @static
     * @param {IGenerateBlockCompletionRequest=} [properties] Properties to set
     * @returns {GenerateBlockCompletionRequest} GenerateBlockCompletionRequest instance
     */
    GenerateBlockCompletionRequest.create = function create(properties) {
        return new GenerateBlockCompletionRequest(properties);
    };

    /**
     * Encodes the specified GenerateBlockCompletionRequest message. Does not implicitly {@link GenerateBlockCompletionRequest.verify|verify} messages.
     * @function encode
     * @memberof GenerateBlockCompletionRequest
     * @static
     * @param {IGenerateBlockCompletionRequest} message GenerateBlockCompletionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateBlockCompletionRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.startKey);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.endKey);
        writer.uint32(/* id 3, wireType 2 =*/26).string(message.prompt);
        writer.uint32(/* id 4, wireType 2 =*/34).string(message.id);
        if (message.history != null && message.history.length)
            for (let i = 0; i < message.history.length; ++i)
                $root.AICompletionHistoryEntry.encode(message.history[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GenerateBlockCompletionRequest message, length delimited. Does not implicitly {@link GenerateBlockCompletionRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GenerateBlockCompletionRequest
     * @static
     * @param {IGenerateBlockCompletionRequest} message GenerateBlockCompletionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateBlockCompletionRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GenerateBlockCompletionRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GenerateBlockCompletionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GenerateBlockCompletionRequest} GenerateBlockCompletionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateBlockCompletionRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GenerateBlockCompletionRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.startKey = reader.string();
                    break;
                }
            case 2: {
                    message.endKey = reader.string();
                    break;
                }
            case 3: {
                    message.prompt = reader.string();
                    break;
                }
            case 4: {
                    message.id = reader.string();
                    break;
                }
            case 5: {
                    if (!(message.history && message.history.length))
                        message.history = [];
                    message.history.push($root.AICompletionHistoryEntry.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("startKey"))
            throw $util.ProtocolError("missing required 'startKey'", { instance: message });
        if (!message.hasOwnProperty("endKey"))
            throw $util.ProtocolError("missing required 'endKey'", { instance: message });
        if (!message.hasOwnProperty("prompt"))
            throw $util.ProtocolError("missing required 'prompt'", { instance: message });
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        return message;
    };

    /**
     * Decodes a GenerateBlockCompletionRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GenerateBlockCompletionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GenerateBlockCompletionRequest} GenerateBlockCompletionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateBlockCompletionRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GenerateBlockCompletionRequest message.
     * @function verify
     * @memberof GenerateBlockCompletionRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GenerateBlockCompletionRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.startKey))
            return "startKey: string expected";
        if (!$util.isString(message.endKey))
            return "endKey: string expected";
        if (!$util.isString(message.prompt))
            return "prompt: string expected";
        if (!$util.isString(message.id))
            return "id: string expected";
        if (message.history != null && message.hasOwnProperty("history")) {
            if (!Array.isArray(message.history))
                return "history: array expected";
            for (let i = 0; i < message.history.length; ++i) {
                let error = $root.AICompletionHistoryEntry.verify(message.history[i]);
                if (error)
                    return "history." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GenerateBlockCompletionRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GenerateBlockCompletionRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GenerateBlockCompletionRequest} GenerateBlockCompletionRequest
     */
    GenerateBlockCompletionRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GenerateBlockCompletionRequest)
            return object;
        let message = new $root.GenerateBlockCompletionRequest();
        if (object.startKey != null)
            message.startKey = String(object.startKey);
        if (object.endKey != null)
            message.endKey = String(object.endKey);
        if (object.prompt != null)
            message.prompt = String(object.prompt);
        if (object.id != null)
            message.id = String(object.id);
        if (object.history) {
            if (!Array.isArray(object.history))
                throw TypeError(".GenerateBlockCompletionRequest.history: array expected");
            message.history = [];
            for (let i = 0; i < object.history.length; ++i) {
                if (typeof object.history[i] !== "object")
                    throw TypeError(".GenerateBlockCompletionRequest.history: object expected");
                message.history[i] = $root.AICompletionHistoryEntry.fromObject(object.history[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GenerateBlockCompletionRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GenerateBlockCompletionRequest
     * @static
     * @param {GenerateBlockCompletionRequest} message GenerateBlockCompletionRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GenerateBlockCompletionRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.history = [];
        if (options.defaults) {
            object.startKey = "";
            object.endKey = "";
            object.prompt = "";
            object.id = "";
        }
        if (message.startKey != null && message.hasOwnProperty("startKey"))
            object.startKey = message.startKey;
        if (message.endKey != null && message.hasOwnProperty("endKey"))
            object.endKey = message.endKey;
        if (message.prompt != null && message.hasOwnProperty("prompt"))
            object.prompt = message.prompt;
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.history && message.history.length) {
            object.history = [];
            for (let j = 0; j < message.history.length; ++j)
                object.history[j] = $root.AICompletionHistoryEntry.toObject(message.history[j], options);
        }
        return object;
    };

    /**
     * Converts this GenerateBlockCompletionRequest to JSON.
     * @function toJSON
     * @memberof GenerateBlockCompletionRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GenerateBlockCompletionRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GenerateBlockCompletionRequest
     * @function getTypeUrl
     * @memberof GenerateBlockCompletionRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GenerateBlockCompletionRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GenerateBlockCompletionRequest";
    };

    return GenerateBlockCompletionRequest;
})();

export const GenerateBlockCompletionReply = $root.GenerateBlockCompletionReply = (() => {

    /**
     * Properties of a GenerateBlockCompletionReply.
     * @exports IGenerateBlockCompletionReply
     * @interface IGenerateBlockCompletionReply
     */

    /**
     * Constructs a new GenerateBlockCompletionReply.
     * @exports GenerateBlockCompletionReply
     * @classdesc Represents a GenerateBlockCompletionReply.
     * @implements IGenerateBlockCompletionReply
     * @constructor
     * @param {IGenerateBlockCompletionReply=} [properties] Properties to set
     */
    function GenerateBlockCompletionReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new GenerateBlockCompletionReply instance using the specified properties.
     * @function create
     * @memberof GenerateBlockCompletionReply
     * @static
     * @param {IGenerateBlockCompletionReply=} [properties] Properties to set
     * @returns {GenerateBlockCompletionReply} GenerateBlockCompletionReply instance
     */
    GenerateBlockCompletionReply.create = function create(properties) {
        return new GenerateBlockCompletionReply(properties);
    };

    /**
     * Encodes the specified GenerateBlockCompletionReply message. Does not implicitly {@link GenerateBlockCompletionReply.verify|verify} messages.
     * @function encode
     * @memberof GenerateBlockCompletionReply
     * @static
     * @param {IGenerateBlockCompletionReply} message GenerateBlockCompletionReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateBlockCompletionReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified GenerateBlockCompletionReply message, length delimited. Does not implicitly {@link GenerateBlockCompletionReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GenerateBlockCompletionReply
     * @static
     * @param {IGenerateBlockCompletionReply} message GenerateBlockCompletionReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateBlockCompletionReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GenerateBlockCompletionReply message from the specified reader or buffer.
     * @function decode
     * @memberof GenerateBlockCompletionReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GenerateBlockCompletionReply} GenerateBlockCompletionReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateBlockCompletionReply.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GenerateBlockCompletionReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GenerateBlockCompletionReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GenerateBlockCompletionReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GenerateBlockCompletionReply} GenerateBlockCompletionReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateBlockCompletionReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GenerateBlockCompletionReply message.
     * @function verify
     * @memberof GenerateBlockCompletionReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GenerateBlockCompletionReply.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a GenerateBlockCompletionReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GenerateBlockCompletionReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GenerateBlockCompletionReply} GenerateBlockCompletionReply
     */
    GenerateBlockCompletionReply.fromObject = function fromObject(object) {
        if (object instanceof $root.GenerateBlockCompletionReply)
            return object;
        return new $root.GenerateBlockCompletionReply();
    };

    /**
     * Creates a plain object from a GenerateBlockCompletionReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GenerateBlockCompletionReply
     * @static
     * @param {GenerateBlockCompletionReply} message GenerateBlockCompletionReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GenerateBlockCompletionReply.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this GenerateBlockCompletionReply to JSON.
     * @function toJSON
     * @memberof GenerateBlockCompletionReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GenerateBlockCompletionReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GenerateBlockCompletionReply
     * @function getTypeUrl
     * @memberof GenerateBlockCompletionReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GenerateBlockCompletionReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GenerateBlockCompletionReply";
    };

    return GenerateBlockCompletionReply;
})();

export const GenerateDiagramSuggestionsRequest = $root.GenerateDiagramSuggestionsRequest = (() => {

    /**
     * Properties of a GenerateDiagramSuggestionsRequest.
     * @exports IGenerateDiagramSuggestionsRequest
     * @interface IGenerateDiagramSuggestionsRequest
     * @property {string} nodeKey GenerateDiagramSuggestionsRequest nodeKey
     */

    /**
     * Constructs a new GenerateDiagramSuggestionsRequest.
     * @exports GenerateDiagramSuggestionsRequest
     * @classdesc Represents a GenerateDiagramSuggestionsRequest.
     * @implements IGenerateDiagramSuggestionsRequest
     * @constructor
     * @param {IGenerateDiagramSuggestionsRequest=} [properties] Properties to set
     */
    function GenerateDiagramSuggestionsRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GenerateDiagramSuggestionsRequest nodeKey.
     * @member {string} nodeKey
     * @memberof GenerateDiagramSuggestionsRequest
     * @instance
     */
    GenerateDiagramSuggestionsRequest.prototype.nodeKey = "";

    /**
     * Creates a new GenerateDiagramSuggestionsRequest instance using the specified properties.
     * @function create
     * @memberof GenerateDiagramSuggestionsRequest
     * @static
     * @param {IGenerateDiagramSuggestionsRequest=} [properties] Properties to set
     * @returns {GenerateDiagramSuggestionsRequest} GenerateDiagramSuggestionsRequest instance
     */
    GenerateDiagramSuggestionsRequest.create = function create(properties) {
        return new GenerateDiagramSuggestionsRequest(properties);
    };

    /**
     * Encodes the specified GenerateDiagramSuggestionsRequest message. Does not implicitly {@link GenerateDiagramSuggestionsRequest.verify|verify} messages.
     * @function encode
     * @memberof GenerateDiagramSuggestionsRequest
     * @static
     * @param {IGenerateDiagramSuggestionsRequest} message GenerateDiagramSuggestionsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateDiagramSuggestionsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.nodeKey);
        return writer;
    };

    /**
     * Encodes the specified GenerateDiagramSuggestionsRequest message, length delimited. Does not implicitly {@link GenerateDiagramSuggestionsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GenerateDiagramSuggestionsRequest
     * @static
     * @param {IGenerateDiagramSuggestionsRequest} message GenerateDiagramSuggestionsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateDiagramSuggestionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GenerateDiagramSuggestionsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GenerateDiagramSuggestionsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GenerateDiagramSuggestionsRequest} GenerateDiagramSuggestionsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateDiagramSuggestionsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GenerateDiagramSuggestionsRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.nodeKey = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nodeKey"))
            throw $util.ProtocolError("missing required 'nodeKey'", { instance: message });
        return message;
    };

    /**
     * Decodes a GenerateDiagramSuggestionsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GenerateDiagramSuggestionsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GenerateDiagramSuggestionsRequest} GenerateDiagramSuggestionsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateDiagramSuggestionsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GenerateDiagramSuggestionsRequest message.
     * @function verify
     * @memberof GenerateDiagramSuggestionsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GenerateDiagramSuggestionsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.nodeKey))
            return "nodeKey: string expected";
        return null;
    };

    /**
     * Creates a GenerateDiagramSuggestionsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GenerateDiagramSuggestionsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GenerateDiagramSuggestionsRequest} GenerateDiagramSuggestionsRequest
     */
    GenerateDiagramSuggestionsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GenerateDiagramSuggestionsRequest)
            return object;
        let message = new $root.GenerateDiagramSuggestionsRequest();
        if (object.nodeKey != null)
            message.nodeKey = String(object.nodeKey);
        return message;
    };

    /**
     * Creates a plain object from a GenerateDiagramSuggestionsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GenerateDiagramSuggestionsRequest
     * @static
     * @param {GenerateDiagramSuggestionsRequest} message GenerateDiagramSuggestionsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GenerateDiagramSuggestionsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.nodeKey = "";
        if (message.nodeKey != null && message.hasOwnProperty("nodeKey"))
            object.nodeKey = message.nodeKey;
        return object;
    };

    /**
     * Converts this GenerateDiagramSuggestionsRequest to JSON.
     * @function toJSON
     * @memberof GenerateDiagramSuggestionsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GenerateDiagramSuggestionsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GenerateDiagramSuggestionsRequest
     * @function getTypeUrl
     * @memberof GenerateDiagramSuggestionsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GenerateDiagramSuggestionsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GenerateDiagramSuggestionsRequest";
    };

    return GenerateDiagramSuggestionsRequest;
})();

export const GenerateDiagramSuggestionsReply = $root.GenerateDiagramSuggestionsReply = (() => {

    /**
     * Properties of a GenerateDiagramSuggestionsReply.
     * @exports IGenerateDiagramSuggestionsReply
     * @interface IGenerateDiagramSuggestionsReply
     * @property {Array.<string>|null} [suggestions] GenerateDiagramSuggestionsReply suggestions
     */

    /**
     * Constructs a new GenerateDiagramSuggestionsReply.
     * @exports GenerateDiagramSuggestionsReply
     * @classdesc Represents a GenerateDiagramSuggestionsReply.
     * @implements IGenerateDiagramSuggestionsReply
     * @constructor
     * @param {IGenerateDiagramSuggestionsReply=} [properties] Properties to set
     */
    function GenerateDiagramSuggestionsReply(properties) {
        this.suggestions = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GenerateDiagramSuggestionsReply suggestions.
     * @member {Array.<string>} suggestions
     * @memberof GenerateDiagramSuggestionsReply
     * @instance
     */
    GenerateDiagramSuggestionsReply.prototype.suggestions = $util.emptyArray;

    /**
     * Creates a new GenerateDiagramSuggestionsReply instance using the specified properties.
     * @function create
     * @memberof GenerateDiagramSuggestionsReply
     * @static
     * @param {IGenerateDiagramSuggestionsReply=} [properties] Properties to set
     * @returns {GenerateDiagramSuggestionsReply} GenerateDiagramSuggestionsReply instance
     */
    GenerateDiagramSuggestionsReply.create = function create(properties) {
        return new GenerateDiagramSuggestionsReply(properties);
    };

    /**
     * Encodes the specified GenerateDiagramSuggestionsReply message. Does not implicitly {@link GenerateDiagramSuggestionsReply.verify|verify} messages.
     * @function encode
     * @memberof GenerateDiagramSuggestionsReply
     * @static
     * @param {IGenerateDiagramSuggestionsReply} message GenerateDiagramSuggestionsReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateDiagramSuggestionsReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.suggestions != null && message.suggestions.length)
            for (let i = 0; i < message.suggestions.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.suggestions[i]);
        return writer;
    };

    /**
     * Encodes the specified GenerateDiagramSuggestionsReply message, length delimited. Does not implicitly {@link GenerateDiagramSuggestionsReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GenerateDiagramSuggestionsReply
     * @static
     * @param {IGenerateDiagramSuggestionsReply} message GenerateDiagramSuggestionsReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateDiagramSuggestionsReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GenerateDiagramSuggestionsReply message from the specified reader or buffer.
     * @function decode
     * @memberof GenerateDiagramSuggestionsReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GenerateDiagramSuggestionsReply} GenerateDiagramSuggestionsReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateDiagramSuggestionsReply.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GenerateDiagramSuggestionsReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.suggestions && message.suggestions.length))
                        message.suggestions = [];
                    message.suggestions.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GenerateDiagramSuggestionsReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GenerateDiagramSuggestionsReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GenerateDiagramSuggestionsReply} GenerateDiagramSuggestionsReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateDiagramSuggestionsReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GenerateDiagramSuggestionsReply message.
     * @function verify
     * @memberof GenerateDiagramSuggestionsReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GenerateDiagramSuggestionsReply.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.suggestions != null && message.hasOwnProperty("suggestions")) {
            if (!Array.isArray(message.suggestions))
                return "suggestions: array expected";
            for (let i = 0; i < message.suggestions.length; ++i)
                if (!$util.isString(message.suggestions[i]))
                    return "suggestions: string[] expected";
        }
        return null;
    };

    /**
     * Creates a GenerateDiagramSuggestionsReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GenerateDiagramSuggestionsReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GenerateDiagramSuggestionsReply} GenerateDiagramSuggestionsReply
     */
    GenerateDiagramSuggestionsReply.fromObject = function fromObject(object) {
        if (object instanceof $root.GenerateDiagramSuggestionsReply)
            return object;
        let message = new $root.GenerateDiagramSuggestionsReply();
        if (object.suggestions) {
            if (!Array.isArray(object.suggestions))
                throw TypeError(".GenerateDiagramSuggestionsReply.suggestions: array expected");
            message.suggestions = [];
            for (let i = 0; i < object.suggestions.length; ++i)
                message.suggestions[i] = String(object.suggestions[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a GenerateDiagramSuggestionsReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GenerateDiagramSuggestionsReply
     * @static
     * @param {GenerateDiagramSuggestionsReply} message GenerateDiagramSuggestionsReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GenerateDiagramSuggestionsReply.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.suggestions = [];
        if (message.suggestions && message.suggestions.length) {
            object.suggestions = [];
            for (let j = 0; j < message.suggestions.length; ++j)
                object.suggestions[j] = message.suggestions[j];
        }
        return object;
    };

    /**
     * Converts this GenerateDiagramSuggestionsReply to JSON.
     * @function toJSON
     * @memberof GenerateDiagramSuggestionsReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GenerateDiagramSuggestionsReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GenerateDiagramSuggestionsReply
     * @function getTypeUrl
     * @memberof GenerateDiagramSuggestionsReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GenerateDiagramSuggestionsReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GenerateDiagramSuggestionsReply";
    };

    return GenerateDiagramSuggestionsReply;
})();

export const GenerateDiagramRequest = $root.GenerateDiagramRequest = (() => {

    /**
     * Properties of a GenerateDiagramRequest.
     * @exports IGenerateDiagramRequest
     * @interface IGenerateDiagramRequest
     * @property {string} nodeKey GenerateDiagramRequest nodeKey
     * @property {string} prompt GenerateDiagramRequest prompt
     */

    /**
     * Constructs a new GenerateDiagramRequest.
     * @exports GenerateDiagramRequest
     * @classdesc Represents a GenerateDiagramRequest.
     * @implements IGenerateDiagramRequest
     * @constructor
     * @param {IGenerateDiagramRequest=} [properties] Properties to set
     */
    function GenerateDiagramRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GenerateDiagramRequest nodeKey.
     * @member {string} nodeKey
     * @memberof GenerateDiagramRequest
     * @instance
     */
    GenerateDiagramRequest.prototype.nodeKey = "";

    /**
     * GenerateDiagramRequest prompt.
     * @member {string} prompt
     * @memberof GenerateDiagramRequest
     * @instance
     */
    GenerateDiagramRequest.prototype.prompt = "";

    /**
     * Creates a new GenerateDiagramRequest instance using the specified properties.
     * @function create
     * @memberof GenerateDiagramRequest
     * @static
     * @param {IGenerateDiagramRequest=} [properties] Properties to set
     * @returns {GenerateDiagramRequest} GenerateDiagramRequest instance
     */
    GenerateDiagramRequest.create = function create(properties) {
        return new GenerateDiagramRequest(properties);
    };

    /**
     * Encodes the specified GenerateDiagramRequest message. Does not implicitly {@link GenerateDiagramRequest.verify|verify} messages.
     * @function encode
     * @memberof GenerateDiagramRequest
     * @static
     * @param {IGenerateDiagramRequest} message GenerateDiagramRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateDiagramRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.nodeKey);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.prompt);
        return writer;
    };

    /**
     * Encodes the specified GenerateDiagramRequest message, length delimited. Does not implicitly {@link GenerateDiagramRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GenerateDiagramRequest
     * @static
     * @param {IGenerateDiagramRequest} message GenerateDiagramRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateDiagramRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GenerateDiagramRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GenerateDiagramRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GenerateDiagramRequest} GenerateDiagramRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateDiagramRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GenerateDiagramRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.nodeKey = reader.string();
                    break;
                }
            case 2: {
                    message.prompt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nodeKey"))
            throw $util.ProtocolError("missing required 'nodeKey'", { instance: message });
        if (!message.hasOwnProperty("prompt"))
            throw $util.ProtocolError("missing required 'prompt'", { instance: message });
        return message;
    };

    /**
     * Decodes a GenerateDiagramRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GenerateDiagramRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GenerateDiagramRequest} GenerateDiagramRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateDiagramRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GenerateDiagramRequest message.
     * @function verify
     * @memberof GenerateDiagramRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GenerateDiagramRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.nodeKey))
            return "nodeKey: string expected";
        if (!$util.isString(message.prompt))
            return "prompt: string expected";
        return null;
    };

    /**
     * Creates a GenerateDiagramRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GenerateDiagramRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GenerateDiagramRequest} GenerateDiagramRequest
     */
    GenerateDiagramRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GenerateDiagramRequest)
            return object;
        let message = new $root.GenerateDiagramRequest();
        if (object.nodeKey != null)
            message.nodeKey = String(object.nodeKey);
        if (object.prompt != null)
            message.prompt = String(object.prompt);
        return message;
    };

    /**
     * Creates a plain object from a GenerateDiagramRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GenerateDiagramRequest
     * @static
     * @param {GenerateDiagramRequest} message GenerateDiagramRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GenerateDiagramRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.nodeKey = "";
            object.prompt = "";
        }
        if (message.nodeKey != null && message.hasOwnProperty("nodeKey"))
            object.nodeKey = message.nodeKey;
        if (message.prompt != null && message.hasOwnProperty("prompt"))
            object.prompt = message.prompt;
        return object;
    };

    /**
     * Converts this GenerateDiagramRequest to JSON.
     * @function toJSON
     * @memberof GenerateDiagramRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GenerateDiagramRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GenerateDiagramRequest
     * @function getTypeUrl
     * @memberof GenerateDiagramRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GenerateDiagramRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GenerateDiagramRequest";
    };

    return GenerateDiagramRequest;
})();

export const GenerateDiagramReply = $root.GenerateDiagramReply = (() => {

    /**
     * Properties of a GenerateDiagramReply.
     * @exports IGenerateDiagramReply
     * @interface IGenerateDiagramReply
     * @property {string|null} [mermaid] GenerateDiagramReply mermaid
     */

    /**
     * Constructs a new GenerateDiagramReply.
     * @exports GenerateDiagramReply
     * @classdesc Represents a GenerateDiagramReply.
     * @implements IGenerateDiagramReply
     * @constructor
     * @param {IGenerateDiagramReply=} [properties] Properties to set
     */
    function GenerateDiagramReply(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GenerateDiagramReply mermaid.
     * @member {string} mermaid
     * @memberof GenerateDiagramReply
     * @instance
     */
    GenerateDiagramReply.prototype.mermaid = "";

    /**
     * Creates a new GenerateDiagramReply instance using the specified properties.
     * @function create
     * @memberof GenerateDiagramReply
     * @static
     * @param {IGenerateDiagramReply=} [properties] Properties to set
     * @returns {GenerateDiagramReply} GenerateDiagramReply instance
     */
    GenerateDiagramReply.create = function create(properties) {
        return new GenerateDiagramReply(properties);
    };

    /**
     * Encodes the specified GenerateDiagramReply message. Does not implicitly {@link GenerateDiagramReply.verify|verify} messages.
     * @function encode
     * @memberof GenerateDiagramReply
     * @static
     * @param {IGenerateDiagramReply} message GenerateDiagramReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateDiagramReply.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.mermaid != null && Object.hasOwnProperty.call(message, "mermaid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.mermaid);
        return writer;
    };

    /**
     * Encodes the specified GenerateDiagramReply message, length delimited. Does not implicitly {@link GenerateDiagramReply.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GenerateDiagramReply
     * @static
     * @param {IGenerateDiagramReply} message GenerateDiagramReply message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GenerateDiagramReply.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GenerateDiagramReply message from the specified reader or buffer.
     * @function decode
     * @memberof GenerateDiagramReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GenerateDiagramReply} GenerateDiagramReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateDiagramReply.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GenerateDiagramReply();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.mermaid = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GenerateDiagramReply message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GenerateDiagramReply
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GenerateDiagramReply} GenerateDiagramReply
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GenerateDiagramReply.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GenerateDiagramReply message.
     * @function verify
     * @memberof GenerateDiagramReply
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GenerateDiagramReply.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.mermaid != null && message.hasOwnProperty("mermaid"))
            if (!$util.isString(message.mermaid))
                return "mermaid: string expected";
        return null;
    };

    /**
     * Creates a GenerateDiagramReply message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GenerateDiagramReply
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GenerateDiagramReply} GenerateDiagramReply
     */
    GenerateDiagramReply.fromObject = function fromObject(object) {
        if (object instanceof $root.GenerateDiagramReply)
            return object;
        let message = new $root.GenerateDiagramReply();
        if (object.mermaid != null)
            message.mermaid = String(object.mermaid);
        return message;
    };

    /**
     * Creates a plain object from a GenerateDiagramReply message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GenerateDiagramReply
     * @static
     * @param {GenerateDiagramReply} message GenerateDiagramReply
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GenerateDiagramReply.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.mermaid = "";
        if (message.mermaid != null && message.hasOwnProperty("mermaid"))
            object.mermaid = message.mermaid;
        return object;
    };

    /**
     * Converts this GenerateDiagramReply to JSON.
     * @function toJSON
     * @memberof GenerateDiagramReply
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GenerateDiagramReply.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GenerateDiagramReply
     * @function getTypeUrl
     * @memberof GenerateDiagramReply
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GenerateDiagramReply.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GenerateDiagramReply";
    };

    return GenerateDiagramReply;
})();

export const BlockRichTextCompletion = $root.BlockRichTextCompletion = (() => {

    /**
     * Properties of a BlockRichTextCompletion.
     * @exports IBlockRichTextCompletion
     * @interface IBlockRichTextCompletion
     * @property {string} summary BlockRichTextCompletion summary
     * @property {string} markdown BlockRichTextCompletion markdown
     */

    /**
     * Constructs a new BlockRichTextCompletion.
     * @exports BlockRichTextCompletion
     * @classdesc Completion to insert rich text
     * @implements IBlockRichTextCompletion
     * @constructor
     * @param {IBlockRichTextCompletion=} [properties] Properties to set
     */
    function BlockRichTextCompletion(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BlockRichTextCompletion summary.
     * @member {string} summary
     * @memberof BlockRichTextCompletion
     * @instance
     */
    BlockRichTextCompletion.prototype.summary = "";

    /**
     * BlockRichTextCompletion markdown.
     * @member {string} markdown
     * @memberof BlockRichTextCompletion
     * @instance
     */
    BlockRichTextCompletion.prototype.markdown = "";

    /**
     * Creates a new BlockRichTextCompletion instance using the specified properties.
     * @function create
     * @memberof BlockRichTextCompletion
     * @static
     * @param {IBlockRichTextCompletion=} [properties] Properties to set
     * @returns {BlockRichTextCompletion} BlockRichTextCompletion instance
     */
    BlockRichTextCompletion.create = function create(properties) {
        return new BlockRichTextCompletion(properties);
    };

    /**
     * Encodes the specified BlockRichTextCompletion message. Does not implicitly {@link BlockRichTextCompletion.verify|verify} messages.
     * @function encode
     * @memberof BlockRichTextCompletion
     * @static
     * @param {IBlockRichTextCompletion} message BlockRichTextCompletion message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BlockRichTextCompletion.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.summary);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.markdown);
        return writer;
    };

    /**
     * Encodes the specified BlockRichTextCompletion message, length delimited. Does not implicitly {@link BlockRichTextCompletion.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BlockRichTextCompletion
     * @static
     * @param {IBlockRichTextCompletion} message BlockRichTextCompletion message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BlockRichTextCompletion.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BlockRichTextCompletion message from the specified reader or buffer.
     * @function decode
     * @memberof BlockRichTextCompletion
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BlockRichTextCompletion} BlockRichTextCompletion
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BlockRichTextCompletion.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.BlockRichTextCompletion();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.summary = reader.string();
                    break;
                }
            case 2: {
                    message.markdown = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("summary"))
            throw $util.ProtocolError("missing required 'summary'", { instance: message });
        if (!message.hasOwnProperty("markdown"))
            throw $util.ProtocolError("missing required 'markdown'", { instance: message });
        return message;
    };

    /**
     * Decodes a BlockRichTextCompletion message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BlockRichTextCompletion
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BlockRichTextCompletion} BlockRichTextCompletion
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BlockRichTextCompletion.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BlockRichTextCompletion message.
     * @function verify
     * @memberof BlockRichTextCompletion
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BlockRichTextCompletion.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.summary))
            return "summary: string expected";
        if (!$util.isString(message.markdown))
            return "markdown: string expected";
        return null;
    };

    /**
     * Creates a BlockRichTextCompletion message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BlockRichTextCompletion
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BlockRichTextCompletion} BlockRichTextCompletion
     */
    BlockRichTextCompletion.fromObject = function fromObject(object) {
        if (object instanceof $root.BlockRichTextCompletion)
            return object;
        let message = new $root.BlockRichTextCompletion();
        if (object.summary != null)
            message.summary = String(object.summary);
        if (object.markdown != null)
            message.markdown = String(object.markdown);
        return message;
    };

    /**
     * Creates a plain object from a BlockRichTextCompletion message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BlockRichTextCompletion
     * @static
     * @param {BlockRichTextCompletion} message BlockRichTextCompletion
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BlockRichTextCompletion.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.summary = "";
            object.markdown = "";
        }
        if (message.summary != null && message.hasOwnProperty("summary"))
            object.summary = message.summary;
        if (message.markdown != null && message.hasOwnProperty("markdown"))
            object.markdown = message.markdown;
        return object;
    };

    /**
     * Converts this BlockRichTextCompletion to JSON.
     * @function toJSON
     * @memberof BlockRichTextCompletion
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BlockRichTextCompletion.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BlockRichTextCompletion
     * @function getTypeUrl
     * @memberof BlockRichTextCompletion
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BlockRichTextCompletion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BlockRichTextCompletion";
    };

    return BlockRichTextCompletion;
})();

/**
 * ContentOperationStatus enum.
 * @exports ContentOperationStatus
 * @enum {number}
 * @property {number} STARTING=0 STARTING value
 * @property {number} RUNNING=1 RUNNING value
 * @property {number} SUCCESS=2 SUCCESS value
 * @property {number} ERROR=3 ERROR value
 */
export const ContentOperationStatus = $root.ContentOperationStatus = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "STARTING"] = 0;
    values[valuesById[1] = "RUNNING"] = 1;
    values[valuesById[2] = "SUCCESS"] = 2;
    values[valuesById[3] = "ERROR"] = 3;
    return values;
})();

/**
 * UpdateFormatVersion enum.
 * @exports UpdateFormatVersion
 * @enum {number}
 * @property {number} UNSPECIFIED=0 UNSPECIFIED value
 * @property {number} V1=1 V1 value
 * @property {number} V2=2 V2 value
 */
export const UpdateFormatVersion = $root.UpdateFormatVersion = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNSPECIFIED"] = 0;
    values[valuesById[1] = "V1"] = 1;
    values[valuesById[2] = "V2"] = 2;
    return values;
})();

export { $root as default };
